/* ==========================================================================
   Stealth Pipes "My Bike" (the Stealth version of Big Gun's Digital Garage)
   Vanilla JS, no dependencies. State in localStorage key sp_garage_v1, max 3 bikes.
   Public API: window.SP.Garage.add(bike) / remove(id) / setActive(id) / setModel(id, model) / list() / active()
               / fits(handle, type) / verdict(handle) / label(b) / short(b) / shopUrl(b) / models(genId)
               / isYours(collectionHandle) / open() / close() / onChange(cb)
   Every write stores b.label and b.short on each bike (the header pre-paint script reads b.label) and fires
   onChange listeners plus a DOM event sp:garage-change {detail: {active, list, reason}}.
   Design rules (CRO): never gates add-to-cart; three steps to a saved bike; the save button
   drops the rider on the one system built for that bike; quiet header chip, not a sub-header.
   Known fit (round 2 item 7): Strategy/2026-10/known-fit/Known-Fit-Design-2026-10-03.md.
   ========================================================================== */
(function () {
  'use strict';
  var KEY = 'sp_garage_v1';
  var MAX = 3;
  var V = window.SP_GARAGE_VOCAB || { makes: [] };
  var K = V.kit || null;
  var listeners = [];

  /* ---------- vocab helpers ---------- */
  function findGen(id) {
    for (var m = 0; m < V.makes.length; m++) for (var f = 0; f < V.makes[m].families.length; f++) for (var g = 0; g < V.makes[m].families[f].generations.length; g++) {
      var gen = V.makes[m].families[f].generations[g];
      if (gen.id === id) return { make: V.makes[m], family: V.makes[m].families[f], gen: gen };
    }
    return null;
  }
  function gensFor(makeName, familyName, year) {
    var out = [];
    V.makes.forEach(function (m) {
      if (m.name !== makeName) return;
      m.families.forEach(function (f) {
        if (f.name !== familyName) return;
        f.generations.forEach(function (g) { if (year >= g.years[0] && year <= g.years[1]) out.push(g); });
      });
    });
    return out;
  }
  function yearsFor(makeName, familyName) {
    var min = 9999, max = 0;
    V.makes.forEach(function (m) { if (m.name !== makeName) return; m.families.forEach(function (f) { if (f.name !== familyName) return; f.generations.forEach(function (g) { min = Math.min(min, g.years[0]); max = Math.max(max, g.years[1]); }); }); });
    return min <= max ? [min, max] : null;
  }
  /* A model answer names the bike only when it is not silent ("Another Softail" keeps "2019 M8 Softail") */
  function modelLabel(b) {
    if (!b || !b.model) return '';
    var r = findGen(b.genId);
    var m = r && (r.gen.models || []).filter(function (x) { return x.id === b.model; })[0];
    return m && !m.silent ? m.label : '';
  }
  function label(b) { return b.year + ' ' + (b.nickname || modelLabel(b) || b.genLabel); }
  function short(b) { var r = findGen(b.genId); return b.nickname || modelLabel(b) || (r && r.gen.short) || b.genLabel; }
  /* The name known-fit copy uses: "2012 Dyna", "2019 M8 Softail", or the rider's nickname */
  function name(b) { return b.nickname ? label(b) : b.year + ' ' + short(b); }
  function shopUrl(b) {
    var r = findGen(b.genId); if (!r) return V.allSystemsUrl || '/collections/all';
    if (r.gen.systems.length === 1) return '/products/' + r.gen.systems[0];
    if (r.gen.systems.length === 0 && r.gen.slipons.length === 1) return '/products/' + r.gen.slipons[0];
    return '/collections/' + r.gen.collection;
  }

  /* ---------- state ---------- */
  function stamp(b) { b.label = label(b); b.short = short(b); }
  function load() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (d && Array.isArray(d.bikes)) {
        /* Backfill b.label / b.short once for bikes saved before they existed (sp2-nav pre-paint reads b.label) */
        var stale = d.bikes.some(function (b) { return b.label !== label(b) || b.short !== short(b); });
        if (stale) { d.bikes.forEach(stamp); try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {} }
        return d;
      }
    } catch (e) {}
    return { bikes: [], activeId: null };
  }
  function save(st, reason) { st.bikes.forEach(stamp); try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} emit(reason); }
  var state = load();
  function emit(reason) {
    listeners.forEach(function (cb) { try { cb(api.active(), api.list()); } catch (e) {} });
    render();
    try { document.dispatchEvent(new CustomEvent('sp:garage-change', { detail: { active: api.active(), list: api.list(), reason: reason || 'change' } })); } catch (e) {}
  }

  /* ---------- fitment ----------
     Every product resolves BY HANDLE (round 2, desktop audit blocker 1: a product type never makes a part
     universal). Kinds: own (a generation's systems / slipons), part (vocab parts, year window per generation),
     model (cut per generation through its Model option), header (universal mufflers and header parts: fit every
     bike with a Stealth 2.25 inch header), general (not tied to a bike), unknown (not mapped: no claim). */
  var HEADER = (V.universalHandles || []).concat(V.headerParts || []);
  /* Saved bikes with the active one first, so it wins a tie. */
  function ordered() {
    var a = api.active();
    return a ? [a].concat(state.bikes.filter(function (x) { return x.id !== a.id; })) : [];
  }
  /* Does this bike run a Stealth 2.25 inch header (so universal mufflers and header parts bolt on)? */
  function takesHeader(b) {
    var hg = K && K.headerGens;
    if (hg) return hg.indexOf(b.genId) > -1;
    var r = findGen(b.genId);
    return !!(r && r.gen.systems.length);
  }
  function modelMap(handle) {
    var m = V.modelOption && V.modelOption[handle];
    if (!m) return null;
    return typeof m.byGen === 'string' ? (K && K[m.byGen]) || null : m.byGen;
  }
  function ownersOf(handle) {
    var owners = [];
    V.makes.forEach(function (m) { m.families.forEach(function (f) { f.generations.forEach(function (g) { if (g.systems.indexOf(handle) > -1 || g.slipons.indexOf(handle) > -1) owners.push(g); }); }); });
    return owners;
  }
  var kindCache = {};
  function kindOf(handle, type) {
    var key = handle + '|' + (type || '');
    if (kindCache[key]) return kindCache[key];
    var t = (type || '').toLowerCase();
    var k;
    if ((V.general || []).indexOf(handle) > -1 || (t && (V.generalTypes || []).indexOf(t) > -1)) k = { kind: 'general' };
    else {
      var own = ownersOf(handle);
      var part = V.parts && V.parts[handle];
      var mm = modelMap(handle);
      if (own.length) k = { kind: 'own', owners: own };
      else if (part) k = { kind: 'part', part: part };
      else if (mm) k = { kind: 'model', map: mm, conf: V.modelOption[handle] };
      else if (HEADER.indexOf(handle) > -1) k = { kind: 'header', conf: K && K.mufflers ? K.mufflers[handle] : null };
      else k = { kind: 'unknown' };
    }
    return (kindCache[key] = k);
  }
  function fitLabelOf(handle, k) {
    k = k || kindOf(handle);
    if (k.kind === 'part') return k.part.fitLabel || '';
    if (k.kind === 'model') return k.conf.fitLabel || '';
    if (k.kind === 'own') return k.owners.map(function (o) { return o.label + ' ' + o.years[0] + ' to ' + o.years[1]; }).join(', ');
    return '';
  }
  /* One bike: fits | header | general | unknown | wrong_year | no_fit | needs_header | not_offered */
  function stateFor(handle, b, k) {
    switch (k.kind) {
      case 'general': return 'general';
      case 'own': return k.owners.some(function (g) { return g.id === b.genId; }) ? 'fits' : 'no_fit';
      case 'part':
        if (!Object.prototype.hasOwnProperty.call(k.part.gens, b.genId)) return 'no_fit';
        var w = k.part.gens[b.genId];
        return !w || (b.year >= w[0] && b.year <= w[1]) ? 'fits' : 'wrong_year';
      case 'model': return k.map[b.genId] ? 'fits' : 'no_fit';
      case 'header':
        if (!takesHeader(b)) return 'needs_header';
        if (k.conf && k.conf.notGens && k.conf.notGens.indexOf(b.genId) > -1) return 'not_offered';
        return 'header';
    }
    return 'unknown';
  }
  var RANK = { fits: 7, header: 6, general: 5, unknown: 5, wrong_year: 3, not_offered: 2, needs_header: 1, no_fit: 0 };
  /* Best state across the given bikes (active first wins ties): { state, bike, kind, k } */
  function verdict(handle, bikes, type) {
    bikes = bikes || ordered();
    var k = kindOf(handle, type);
    var best = null;
    bikes.forEach(function (b) {
      var s = stateFor(handle, b, k);
      if (!best || RANK[s] > RANK[best.state]) best = { state: s, bike: b };
    });
    if (!best) return { state: k.kind === 'general' || k.kind === 'unknown' ? k.kind : 'no_bike', bike: null, kind: k.kind, k: k };
    best.kind = k.kind; best.k = k;
    return best;
  }

  /* PDP verdict (fitment panel and the chip under the title). Shapes the d7f8117 renderer reads:
     fits      -> bike = the first saved bike it fits; other = true when that is not the active bike
     no_fit    -> none fit; many = more than one bike saved
     wrong_year -> right platform, outside the part's years (window)
     universal -> bike = the active bike only when it runs a Stealth header; headerless = the active bike
                  when it does not; other = a saved bike with a Stealth header when the active one has none
     model     -> cut per generation through a Model option (renderModelFit decides from the selected value)
     no_bike / unknown */
  function fits(handle, type) {
    var b = api.active();
    var bikes = ordered();
    var k = kindOf(handle, type);
    var r = b ? findGen(b.genId) : null;
    if (k.kind === 'general' || k.kind === 'unknown') return { status: 'unknown', bike: b, gen: r ? r.gen : null };
    if (k.kind === 'header') {
      var actHas = !!(b && stateFor(handle, b, k) === 'header');
      var withHeader = bikes.filter(function (x) { return stateFor(handle, x, k) === 'header'; })[0] || null;
      return { status: 'universal', bike: actHas ? b : null, headerless: b && !takesHeader(b) ? b : null, notOffered: b && takesHeader(b) && !actHas ? b : null, muffler: k.conf ? k.conf.name : '', other: !actHas ? withHeader : null, gen: r ? r.gen : null, slipon: (V.universalHandles || []).indexOf(handle) > -1 };
    }
    var fitLabel = fitLabelOf(handle, k);
    if (k.kind === 'model') return { status: b ? 'model' : 'no_bike', bike: b, k: k, fitLabel: fitLabel };
    if (!b) return { status: 'no_bike', fitLabel: fitLabel, k: k };
    for (var i = 0; i < bikes.length; i++) {
      if (stateFor(handle, bikes[i], k) === 'fits') {
        var gen = k.kind === 'own' ? k.owners.filter(function (g) { return g.id === bikes[i].genId; })[0] : (findGen(bikes[i].genId) || {}).gen;
        return { status: 'fits', bike: bikes[i], gen: gen, other: bikes[i].id !== b.id, k: k, fitLabel: fitLabel };
      }
    }
    for (var j = 0; j < bikes.length; j++) {
      if (stateFor(handle, bikes[j], k) === 'wrong_year') return { status: 'wrong_year', bike: bikes[j], window: k.part.gens[bikes[j].genId], k: k, fitLabel: fitLabel };
    }
    return { status: 'no_fit', bike: b, gen: r ? r.gen : null, many: bikes.length > 1, k: k, fitLabel: fitLabel };
  }

  /* ---------- public api ---------- */
  var api = {
    list: function () { return state.bikes.slice(); },
    active: function () { return state.bikes.filter(function (b) { return b.id === state.activeId; })[0] || state.bikes[0] || null; },
    add: function (bike) {
      var r = findGen(bike.genId); if (!r) return null;
      var b = { id: 'b' + Date.now().toString(36), make: r.make.name, family: r.family.name, genId: r.gen.id, genLabel: r.gen.label, year: bike.year, nickname: (bike.nickname || '').trim().slice(0, 40), at: Date.now() };
      state.bikes = state.bikes.filter(function (x) { return !(x.genId === b.genId && x.year === b.year && x.nickname === b.nickname); });
      state.bikes.unshift(b);
      if (state.bikes.length > MAX) state.bikes = state.bikes.slice(0, MAX);
      state.activeId = b.id;
      kfClearAll();
      save(state, 'add');
      track(b);
      return b;
    },
    remove: function (id) { state.bikes = state.bikes.filter(function (b) { return b.id !== id; }); if (state.activeId === id) state.activeId = state.bikes[0] ? state.bikes[0].id : null; save(state, 'remove'); },
    setActive: function (id) { state.activeId = id; kfClearAll(); save(state, 'active'); },
    /* Optional model answer, no picker step (agreed with sp2-drawer 2026-10-03): model ids come from the
       generation's vocab "models"; null clears it. Returns the bike, or null for an unknown bike or model. */
    setModel: function (id, model) {
      var b = state.bikes.filter(function (x) { return x.id === id; })[0];
      if (!b) return null;
      if (model == null) delete b.model;
      else {
        var r = findGen(b.genId);
        if (!r || !(r.gen.models || []).some(function (m) { return m.id === model; })) return null;
        b.model = model;
      }
      save(state, 'model');
      identify();
      return b;
    },
    modelFit: modelFit,
    /* One stored answer per bike for universal slip-ons (agreed with sp2-pdp and sp2-drawer): 'stealth' | 'stock'
       | null (not asked). Fires sp:garage-change {reason: 'headers'}. */
    setHeaders: function (id, value) {
      var b = state.bikes.filter(function (x) { return x.id === id; })[0];
      if (!b || (value != null && value !== 'stealth' && value !== 'stock')) return null;
      if (value == null) delete b.headers; else b.headers = value;
      save(state, 'headers');
      return b;
    },
    models: function (genId) { var r = findGen(genId); return r && r.gen.models ? r.gen.models.map(function (m) { return { id: m.id, label: m.label, silent: !!m.silent }; }) : []; },
    fits: fits,
    verdict: function (handle, type) { var v = verdict(handle, null, type); return { state: v.state, bike: v.bike, label: v.bike ? label(v.bike) : '', short: v.bike ? short(v.bike) : '', fitLabel: fitLabelOf(handle) }; },
    shopUrl: shopUrl,
    label: label,
    short: short,
    isYours: function (collectionHandle) { return state.bikes.some(function (b) { var r = findGen(b.genId); return r && r.gen.collection === collectionHandle; }); },
    onChange: function (cb) { listeners.push(cb); },
    open: openDrawer,
    close: closeDrawer,
    /* Known-fit controls for other surfaces (agreed with sp2-collection 2026-10-03):
       kf.select(surface, bikeId | null) scopes that surface to one saved bike (null = every bike) and re-runs it;
       kf.showAll(surface, on); kf.state(surface) -> { selected, all }. Each scope run fires sp:kf-scoped. */
    kf: {
      select: function (surface, id) { kfSetSel(surface, id || ''); kfSetAll(surface, false); renderLists(); },
      showAll: function (surface, on) { kfSetAll(surface, on !== false); if (on !== false) publish('known_fit_show_all', { surface: surface, path: location.pathname }); renderLists(); },
      state: function (surface) { return { selected: kfSel(surface) || null, all: kfAll(surface) }; },
      /* How many of these handles the scope would show right now (Collection V3's filter sheet "Show N"):
         the bike selection and Show all are honoured; dealers, no bike, Show all and the zero guard show all */
      count: function (surface, handles) {
        handles = (handles || []).filter(Boolean);
        var all = ordered(), sel = kfSel(surface);
        var bikes = all.filter(function (b) { return !sel || b.id === sel; });
        if (!bikes.length) bikes = all;
        if (!bikes.length || isDealer() || kfAll(surface)) return handles.length;
        var c = classify(handles, bikes);
        if (!c.fit.length && !c.header.length) return handles.length;
        return c.fit.length + c.header.length + c.general.length;
      }
    }
  };
  window.SP = window.SP || {};
  window.SP.Garage = api;

  /* Klaviyo hook: silent if the visitor is already identified, nothing otherwise. */
  function identify() {
    try { var k = window.klaviyo || window._learnq; if (k && typeof k.push === 'function') k.push(['identify', { 'Saved Bikes': state.bikes.map(label).join(' | ') }]); } catch (e) {}
  }
  function track(b) {
    try {
      var k = window.klaviyo || window._learnq;
      if (!k || typeof k.push !== 'function') return;
      k.push(['track', 'Saved Bike', { Make: b.make, Family: b.family, Generation: b.genLabel, Year: b.year, Nickname: b.nickname, ShopURL: location.origin + shopUrl(b) }]);
    } catch (e) {}
    identify();
  }

  /* ---------- picker (shared by drawer + inline mounts) ---------- */
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var LOCK = '<svg class="sp-picker__lock" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="5" y="11" width="14" height="9" rx="1.5"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
  /* A step that is not open yet: focusable, aria-disabled, lock icon, and the reason for screen readers
     (coordinator ruling: disabled token #8c8c8c on #222, 4.73:1, never opacity) */
  function stepBtn(go, text, open, why) {
    return '<button type="button" data-goto="' + go + '"' + (open ? '>' + text : ' aria-disabled="true">' + LOCK + text + '<span class="visually-hidden"> (' + why + ')</span>') + '</button>';
  }
  function buildPicker(host, opts) {
    opts = opts || {};
    var sel = { make: null, family: null, year: null, genId: null, nickname: '' };
    function step() {
      if (!sel.make) return 'make';
      if (!sel.family) return 'family';
      if (!sel.year) return 'year';
      var g = gensFor(sel.make, sel.family, sel.year);
      if (g.length > 1 && !sel.genId) return 'engine';
      return 'done';
    }
    function draw(moveFocus) {
      var s = step();
      var makes = V.makes;
      var html = '<div class="sp-picker" data-step="' + s + '">';
      html += '<ol class="sp-picker__steps">' +
        '<li class="' + (s === 'make' ? 'is-current' : 'is-done') + '">' + stepBtn('make', sel.make ? esc(sel.make) : 'Make', true) + '</li>' +
        '<li class="' + (s === 'family' ? 'is-current' : sel.family ? 'is-done' : 'is-locked') + '">' + stepBtn('family', sel.family ? esc(sel.family) : 'Family', !!sel.make, 'pick a make first') + '</li>' +
        '<li class="' + (s === 'year' ? 'is-current' : sel.year ? 'is-done' : 'is-locked') + '">' + stepBtn('year', sel.year ? sel.year : 'Year', !!sel.family, sel.make ? 'pick a family first' : 'pick a make first') + '</li>' +
        '</ol>';
      if (s === 'make') {
        html += '<div class="sp-picker__grid sp-picker__grid--make">' + makes.map(function (m) { return '<button type="button" class="sp-picker__opt" data-make="' + esc(m.name) + '">' + esc(m.name) + '</button>'; }).join('') + '</div>';
      } else if (s === 'family') {
        var mk = makes.filter(function (m) { return m.name === sel.make; })[0];
        html += '<div class="sp-picker__grid">' + mk.families.map(function (f) { var yr = yearsFor(sel.make, f.name); return '<button type="button" class="sp-picker__opt" data-family="' + esc(f.name) + '">' + esc(f.name) + '<small>' + (yr ? yr[0] + ' to ' + yr[1] : '') + '</small></button>'; }).join('') + '</div>';
      } else if (s === 'year') {
        var yr2 = yearsFor(sel.make, sel.family) || [1984, 2026];
        var years = [];
        for (var y = yr2[1]; y >= yr2[0]; y--) years.push(y);
        html += '<div class="sp-picker__years">' + years.map(function (y) { return '<button type="button" class="sp-picker__year" data-year="' + y + '">' + y + '</button>'; }).join('') + '</div>';
      } else if (s === 'engine') {
        var g2 = gensFor(sel.make, sel.family, sel.year);
        /* Same rule as the home hero finder (sp3-home.js askKind): the engine question only when every generation
           names a distinct engine; otherwise the model (2021 to 2026 Sportster, hero QA 2026-10-15 finding 3) */
        var seenE = {}, askM = false;
        g2.forEach(function (g) { if (!g.engine || seenE[g.engine]) askM = true; seenE[g.engine] = 1; });
        html += '<p class="sp-picker__hint" data-ask="' + (askM ? 'model' : 'engine') + '">' + sel.year + ' was a changeover year. ' + (askM ? 'Which model is it?' : 'Which engine is in it?') + '</p><div class="sp-picker__grid">' + g2.map(function (g) { return '<button type="button" class="sp-picker__opt" data-gen="' + esc(g.id) + '">' + esc(askM ? g.label : g.engine) + (askM ? '' : '<small>' + esc(g.label) + '</small>') + '</button>'; }).join('') + '</div>';
      } else {
        var g3 = sel.genId ? findGen(sel.genId).gen : gensFor(sel.make, sel.family, sel.year)[0];
        sel.genId = g3.id;
        html += '<div class="sp-picker__done">' +
          '<p class="sp-picker__summary"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>' + sel.year + ' ' + esc(g3.label) + '</p>' +
          (g3.note ? '<p class="sp-picker__note">' + esc(g3.note) + '</p>' : '') +
          '<label class="sp-picker__nick"><span>Model or nickname (optional)</span><input type="text" maxlength="40" placeholder="Street Bob, Road Glide, the blue one" data-nick></label>' +
          '<button type="button" class="btn sp-picker__save" data-save>' + (opts.saveText || 'Save my bike') + '</button>' +
          '</div>';
      }
      html += '</div>';
      host.innerHTML = html;
      var nick = host.querySelector('[data-nick]');
      if (nick) nick.value = sel.nickname;
      /* Each rebuild replaced the button that had focus, so Tab went back to Close (WDG review 2026-10-05). After a
         rider's step change, focus the new step's first option (the summary on the last step, so no phone keyboard
         opens) and say the step in the garage live region. */
      if (moveFocus) {
        var tgt = s === 'done' ? host.querySelector('.sp-picker__summary') : host.querySelector('.sp-picker__opt, .sp-picker__year');
        if (tgt) { if (s === 'done') tgt.setAttribute('tabindex', '-1'); tgt.focus({ preventScroll: true }); }
        var say = { make: 'Pick a make.', family: 'Pick a family.', year: 'Pick a year.', engine: (host.querySelector('.sp-picker__hint[data-ask="model"]') ? 'Pick the model.' : 'Pick the engine.') }[s];
        announce(say || ('Ready to save: ' + (host.querySelector('.sp-picker__summary') || {}).textContent));
      }
    }
    host.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t || t.getAttribute('aria-disabled') === 'true') return;
      if (t.dataset.goto) { var g = t.dataset.goto; if (g === 'make') { sel = { make: null, family: null, year: null, genId: null, nickname: sel.nickname }; } else if (g === 'family') { sel.family = null; sel.year = null; sel.genId = null; } else if (g === 'year') { sel.year = null; sel.genId = null; } draw(true); return; }
      if (t.dataset.make) { sel.make = t.dataset.make; draw(true); return; }
      if (t.dataset.family) { sel.family = t.dataset.family; draw(true); return; }
      if (t.dataset.year) { sel.year = parseInt(t.dataset.year, 10); draw(true); return; }
      if (t.dataset.gen) { sel.genId = t.dataset.gen; draw(true); return; }
      if (t.hasAttribute('data-save')) {
        var n = host.querySelector('[data-nick]'); sel.nickname = n ? n.value : '';
        var b = api.add({ genId: sel.genId, year: sel.year, nickname: sel.nickname });
        if (b && opts.onSave) opts.onSave(b);
        return;
      }
    });
    host.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches('[data-nick]')) { e.preventDefault(); var s = host.querySelector('[data-save]'); if (s) s.click(); } });
    draw();
    return { reset: function () { sel = { make: null, family: null, year: null, genId: null, nickname: '' }; draw(); } };
  }

  /* ---------- drawer ----------
     Focus (desktop audit C5): the opener is remembered; Tab cycles inside; the page behind is inert while open;
     Escape and Close return focus to the opener. After a save on a page that re-renders for the bike (PDP,
     scoped lists, home), the drawer closes and focus moves to what changed (mobile audit defect 10). */
  var drawer, overlay, body, lastFocus, inerted = [];
  function drawerEls() {
    drawer = drawer || document.querySelector('[data-sp-garage-drawer]');
    overlay = overlay || document.querySelector('[data-sp-garage-overlay]');
    body = body || (drawer && drawer.querySelector('[data-sp-garage-body]'));
    return !!drawer;
  }
  function focusables() {
    return Array.prototype.filter.call(drawer.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex]:not([tabindex="-1"])'), function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
  }
  function setInert(on) {
    if (on) {
      inerted = Array.prototype.filter.call(document.body.children, function (el) {
        return el !== drawer && el !== overlay && !el.contains(drawer) && el.tagName !== 'SCRIPT' && !el.inert;
      });
      inerted.forEach(function (el) { el.inert = true; });
    } else {
      inerted.forEach(function (el) { el.inert = false; });
      inerted = [];
    }
  }
  /* addFirst: an "Add another bike" opener (data-sp-garage-add, the home hero plate) lands on the picker with the
     add section already open instead of the bike list, one tap less (hero QA 2026-10-15 observation C) */
  function openDrawer(addFirst) {
    if (!drawerEls()) return;
    if (!drawer.classList.contains('is-open')) lastFocus = document.activeElement;
    renderDrawer();
    drawer.classList.add('is-open'); overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sp-garage-open');
    setInert(true);
    var f = drawer.querySelector('button, input');
    var add = addFirst && body ? body.querySelector('details.sp-garage__add') : null;
    if (add) { add.open = true; var fa = add.querySelector('[data-sp-picker] button, [data-sp-picker] input'); if (fa) f = fa; }
    if (f) f.focus();
  }
  function closeDrawer(focusTo) {
    if (!drawerEls()) return;
    var wasOpen = drawer.classList.contains('is-open');
    drawer.classList.remove('is-open'); overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sp-garage-open');
    setInert(false);
    if (!wasOpen) return;
    if (focusTo && focusTo.focus) { if (!focusTo.hasAttribute('tabindex')) focusTo.setAttribute('tabindex', '-1'); focusTo.focus({ preventScroll: true }); }
    else if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus();
    try { document.dispatchEvent(new CustomEvent('sp:garage-close')); } catch (e) {} /* the cart drawer reopens itself (CR-20) */
  }
  var live;
  function announce(text) {
    if (!live) { live = document.createElement('div'); live.className = 'visually-hidden'; live.setAttribute('aria-live', 'polite'); live.setAttribute('data-sp-garage-live', ''); document.body.appendChild(live); }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 60);
  }
  /* Where the rider's attention belongs after a save, or null to keep the sheet open (cart, pages, account) */
  function afterSaveTarget() {
    var pdp = document.querySelector('[data-sp-fitline], [data-section-type="product"] [data-your-bike]:not(:empty), [data-sp-fitment]:not([hidden])');
    if (pdp) return { el: pdp, say: function (b) { var t = pdp.textContent.replace(/\s+/g, ' ').replace(/\s*change( bike)?\s*$/i, '').trim(); return 'Saved your ' + name(b) + '. ' + t; } };
    var banner = document.querySelector('[data-sp-kf-banner]:not([hidden]) .sp-kf-banner__title');
    if (banner) return { el: banner, say: function () { return banner.textContent; } };
    var row = document.querySelector('[data-sp-kf="row"] [data-sp-kf-label]:not([hidden])') || document.querySelector('[data-sp-kf-hero]');
    if (row) return { el: null, say: function (b) { return 'Saved your ' + name(b) + '. The page now shows what fits it.'; } };
    return null;
  }
  function renderDrawer() {
    if (!drawerEls()) return;
    var bikes = api.list(), act = api.active();
    var html = '';
    if (bikes.length) {
      html += '<ul class="sp-garage__list">' + bikes.map(function (b) {
        var isA = act && act.id === b.id;
        return '<li class="sp-garage__bike' + (isA ? ' is-active' : '') + '">' +
          '<label class="sp-garage__radio"><input type="radio" name="sp-active-bike" value="' + b.id + '"' + (isA ? ' checked' : '') + ' data-set-active><span>' + esc(label(b)) + '</span><small>' + esc(b.make + ' ' + b.family) + '</small></label>' +
          '<a class="btn sp-garage__shop" href="' + shopUrl(b) + '">Shop for it</a>' +
          '<button type="button" class="sp-garage__remove" data-remove="' + b.id + '" aria-label="Remove ' + esc(label(b)) + '">Remove</button>' +
          '</li>';
      }).join('') + '</ul>';
      if (bikes.length < MAX) html += '<details class="sp-garage__add"><summary>Add another bike</summary><div data-sp-picker></div></details>';
    } else {
      html += '<p class="sp-garage__intro">Tell us what you ride and every page shows what fits it. Make, family, year. No account needed.</p><div data-sp-picker></div>';
    }
    html += '<p class="sp-garage__foot">Stored on this device only. <a href="' + (V.allSystemsUrl || '/collections/all') + '">Browse every system</a></p>';
    body.innerHTML = html;
    var mount = body.querySelector('[data-sp-picker]');
    if (mount) buildPicker(mount, { onSave: function (b) {
      /* A page that re-renders for the bike (PDP, scoped lists, home rows, hero) closes the sheet; the lists land a
         tick later (promises), so the focus target is read after them */
      if (document.querySelector('[data-sp-fitline], [data-sp-fitment], [data-section-type="product"] [data-your-bike], [data-sp-kf-banner], [data-sp-kf="row"], a[href$="#bike-finder"], [data-sp-kf-hero]')) {
        setTimeout(function () {
          var t2 = afterSaveTarget();
          var el = t2 && t2.el;
          if (el && (el.getBoundingClientRect().top < 0 || el.getBoundingClientRect().bottom > window.innerHeight)) el.scrollIntoView({ block: 'center' });
          closeDrawer(el);
          /* PDP V3's fit line announces itself (sp2-pdp), so it is not said twice */
          if (t2 && !document.querySelector('[data-sp-fitline]')) announce(t2.say(b));
        }, 60);
        return;
      }
      renderDrawer(); var s = body.querySelector('.sp-garage__bike.is-active'); if (s) s.scrollIntoView({ block: 'nearest' });
    } });
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-sp-garage-open]');
    if (open) { e.preventDefault(); openDrawer(open.hasAttribute('data-sp-garage-add')); return; }
    var close = e.target.closest('[data-sp-garage-close], [data-sp-garage-overlay]');
    if (close) { e.preventDefault(); closeDrawer(); return; }
    var sa = e.target.closest('[data-sp-set-active]');
    if (sa) { e.preventDefault(); api.setActive(sa.dataset.spSetActive); return; }
    var rm = e.target.closest('[data-remove]');
    if (rm && drawer && drawer.contains(rm)) { api.remove(rm.dataset.remove); renderDrawer(); var f = drawer.querySelector('button, input'); if (f) f.focus(); return; }
  });
  document.addEventListener('change', function (e) { if (e.target.matches('[data-set-active]')) { api.setActive(e.target.value); renderDrawer(); var r = drawer.querySelector('[data-set-active]:checked'); if (r) r.focus(); } });
  document.addEventListener('keydown', function (e) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });

  /* ---------- render points ---------- */
  var ICON = {
    tick: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>',
    info: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/></svg>',
    bike: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 17a3 3 0 1 0 0 .01M19 17a3 3 0 1 0 0 .01M5 17l3-7h6l2 4h3M9 10l2-3h3"/></svg>'
  };
  function yrs(w) { return w[0] + ' to ' + w[1]; }

  /* ----- Model option products (header replacement, replacement bracket), desktop audit blocker C4 -----
     The saved bike's Model is preselected through the theme's own variant inputs, so price, image, stock and the
     sticky bar follow. Never when the URL names a variant, and never over a rider's own pick on this page until
     the bike changes. The verdict reads the Model that is selected right now. */
  function modelInputs(section) {
    return Array.prototype.filter.call(section.querySelectorAll('[data-variant-input]'), function (i) {
      var wrap = i.closest('.variant-input-wrap');
      return /^model/i.test(i.name || '') || (wrap && /^model/.test(wrap.getAttribute('data-handle') || ''));
    });
  }
  function selectedModel(section) {
    var v = '';
    modelInputs(section).forEach(function (i) { if (i.tagName === 'SELECT') v = i.value; else if (i.checked) v = i.value; });
    return v;
  }
  function pickModel(section, value) {
    var done = false;
    modelInputs(section).forEach(function (i) {
      if (done) return;
      if (i.tagName === 'SELECT') {
        if (Array.prototype.some.call(i.options, function (o) { return o.value === value; }) && i.value !== value) { i.value = value; i.dispatchEvent(new Event('change', { bubbles: true })); done = true; }
      } else if (i.value === value) {
        if (!i.checked) { i.checked = true; i.dispatchEvent(new Event('change', { bubbles: true })); }
        done = true;
      }
    });
    return done;
  }
  function hookModelSection(section) {
    if (section.dataset.spModelHook) return;
    section.dataset.spModelHook = '1';
    section.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('[data-variant-input]')) return;
      if (e.isTrusted && modelInputs(section).indexOf(e.target) > -1) section.dataset.spModelTouched = '1';
      setTimeout(render, 0);
    });
  }
  var variantInUrl = /[?&]variant=\d/.test(window.location.search);
  function preselectModel(section, handle, b, map) {
    var want = b && map[b.genId];
    if (!want) return false;
    var key = b.id + '|' + want;
    if (section.dataset.spModelBike && section.dataset.spModelBike !== b.id) delete section.dataset.spModelTouched;
    section.dataset.spModelBike = b.id;
    if (variantInUrl || section.dataset.spModelTouched || section.dataset.spModelPre === key) return false;
    section.dataset.spModelPre = key;
    var changed = pickModel(section, want);
    publish('known_fit_apply', { surface: 'pdp_model', preselected: changed, product: handle });
    return changed;
  }
  /* { state: fits | wrong_model | none | no_bike, bike, want, sel, other } */
  function modelVerdict(section, handle, r) {
    var map = r.k.map, b = r.bike;
    if (!b) return { state: 'no_bike' };
    hookModelSection(section);
    preselectModel(section, handle, b, map);
    var sel = selectedModel(section), want = map[b.genId];
    var other = ordered().filter(function (x) { return x.id !== b.id && map[x.genId]; })[0] || null;
    if (!want) return { state: 'none', bike: b, other: other };
    if (sel === want) return { state: 'fits', bike: b, want: want, sel: sel, auto: section.dataset.spModelPre === b.id + '|' + want && !section.dataset.spModelTouched };
    return { state: 'wrong_model', bike: b, want: want, sel: sel };
  }
  /* Preselect on every product section of a Model product, whatever renders its fit line (V2 panel or V3 fit line) */
  function preselectAll() {
    var b = api.active();
    if (!b) return;
    document.querySelectorAll('[data-section-type="product"]').forEach(function (sec) {
      var el = sec.querySelector('[data-sp-fitline][data-handle], [data-sp-fitment]');
      var h = el ? el.getAttribute('data-handle') : sec.getAttribute('data-product-handle');
      if (!h) return;
      var k = kindOf(h);
      if (k.kind !== 'model') return;
      hookModelSection(sec);
      preselectModel(sec, h, b, k.map);
    });
  }
  /* For PDP V3's fit line (agreed with sp2-pdp): the verdict for a Model product and the value it shows.
     { state: fits | other_model | not_made | no_bike, bike, wantValue, otherBike } */
  function modelFit(handle, selected) {
    var k = kindOf(handle);
    if (k.kind !== 'model') return null;
    var b = api.active();
    if (!b) return { state: 'no_bike', bike: null, wantValue: '', otherBike: null };
    var want = k.map[b.genId] || '';
    var other = ordered().filter(function (x) { return x.id !== b.id && k.map[x.genId]; })[0] || null;
    if (!want) return { state: 'not_made', bike: b, wantValue: '', otherBike: other };
    return { state: selected === want ? 'fits' : 'other_model', bike: b, wantValue: want, otherBike: other };
  }
  function partNoun(handle) { var m = V.modelOption && V.modelOption[handle]; return (m && m.noun) || 'part'; }

  function render() {
    var act = api.active();
    /* Header chip */
    document.querySelectorAll('[data-sp-garage-chip]').forEach(function (el) {
      var t = el.querySelector('[data-sp-garage-chip-text]');
      if (t) t.textContent = act ? label(act) : (el.dataset.emptyText || 'My bike');
      el.classList.toggle('has-bike', !!act);
      el.setAttribute('aria-label', act ? 'Your bike: ' + label(act) + '. Open My Bike' : 'Add your bike');
    });
    /* Inline chips (PDP header, collection note) */
    document.querySelectorAll('[data-your-bike]').forEach(function (el) {
      if (!act) { el.innerHTML = el.dataset.emptyCta ? '<button type="button" class="sp-yourbike sp-yourbike--empty" data-sp-garage-open>' + ICON.bike + esc(el.dataset.emptyCta) + '</button>' : ''; return; }
      /* On a PDP the chip gives the same verdict as the fitment panel, so it never reads as a yes on a system that does not fit */
      var sec = el.closest('[data-section-type="product"]');
      var fp = sec && sec.querySelector('[data-sp-fitment]');
      /* Templates without the fitment block (the muffler templates) still give a verdict from the section's handle */
      var fh = fp ? fp.dataset.handle : (sec && sec.dataset.productHandle);
      var fr = fh ? fits(fh, fp ? fp.dataset.type : '') : null;
      var change = '<button type="button" data-sp-garage-open>change</button>';
      if (fr && fr.status === 'model') {
        var mv = modelVerdict(sec, fh, fr);
        if (mv.state === 'fits') { el.innerHTML = '<span class="sp-yourbike sp-yourbike--fits">' + ICON.tick + '<span>Fits your <a href="' + shopUrl(mv.bike) + '">' + esc(label(mv.bike)) + '</a></span>' + change + '</span>'; return; }
        if (mv.state === 'wrong_model') { el.innerHTML = '<span class="sp-yourbike sp-yourbike--no_fit">' + ICON.info + '<span>Pick ' + esc(mv.want) + ' for your ' + esc(label(mv.bike)) + '</span>' + change + '</span>'; return; }
        el.innerHTML = '<span class="sp-yourbike sp-yourbike--no_fit">' + ICON.info + '<span>Not made for your ' + esc(label(mv.bike)) + '. <a href="' + shopUrl(mv.bike) + '">See what fits it</a></span>' + change + '</span>';
        return;
      }
      if (fr && fr.status === 'fits') {
        el.innerHTML = '<span class="sp-yourbike sp-yourbike--fits">' + ICON.tick + '<span>Fits your <a href="' + shopUrl(fr.bike) + '">' + esc(label(fr.bike)) + '</a></span>' +
          (fr.other ? '<button type="button" data-sp-set-active="' + esc(fr.bike.id) + '">Make it my active bike</button>' : change) + '</span>';
      } else if (fr && (fr.status === 'no_fit' || fr.status === 'wrong_year')) {
        var nb0 = fr.status === 'wrong_year' ? fr.bike : act;
        el.innerHTML = '<span class="sp-yourbike sp-yourbike--no_fit">' + ICON.info + '<span>' + (fr.status === 'wrong_year' ? 'Fits ' + esc(fr.fitLabel) + ', not your ' + esc(label(nb0)) : fr.many ? 'Not built for any of your saved bikes' : 'Not built for your ' + esc(label(act))) + '. <a href="' + shopUrl(nb0) + '">See what fits your ' + esc(label(nb0)) + '</a></span>' + change + '</span>';
      } else if (fr && fr.status === 'universal' && (fr.headerless || fr.notOffered)) {
        /* A universal muffler or header part names a bike only when that bike runs a Stealth header that takes it
           (parity C); a second saved bike that does gets the switch (parity D) */
        var nb = fr.headerless || fr.notOffered;
        var why = fr.headerless ? 'Bolts to a Stealth header. Your ' + esc(label(nb)) + ' does not use one.' : 'The Stealth system for your ' + esc(label(nb)) + ' is not built with the ' + esc(fr.muffler) + '.';
        var otherBtn = fr.other ? '<span>It fits your ' + esc(label(fr.other)) + '.</span><button type="button" data-sp-set-active="' + esc(fr.other.id) + '">Make it my active bike</button>' : change;
        el.innerHTML = '<span class="sp-yourbike sp-yourbike--no_fit">' + ICON.info + '<span>' + why + ' <a href="' + shopUrl(nb) + '">Shop parts for my ' + esc(label(nb)) + '</a></span>' + otherBtn + '</span>';
      } else if (fr && fr.status === 'universal') {
        el.innerHTML = '<span class="sp-yourbike sp-yourbike--fits">' + ICON.tick + '<span>Fits every Stealth header' + (fr.bike ? ', including your ' + esc(label(fr.bike)) : '') + '</span></span>';
      } else {
        /* A collection note chip hides while the known-fit banner names the bike (design 4.3.7, CSS) */
        el.innerHTML = '<span class="sp-yourbike">' + ICON.bike + 'Your bike: <a href="' + shopUrl(act) + '">' + esc(label(act)) + '</a>' + change + '</span>';
      }
    });
    /* PDP fitment panel */
    document.querySelectorAll('[data-sp-fitment]').forEach(renderFitment);
    /* Inline mounts (bike finder section) */
    document.querySelectorAll('[data-sp-garage-mount]').forEach(function (m) {
      if (m.dataset.spMounted) { var res = m.querySelector('[data-sp-garage-result]'); if (res) res.innerHTML = act ? resultHTML(act) : ''; return; }
      m.dataset.spMounted = '1';
      m.innerHTML = '<div data-sp-garage-result>' + (act ? resultHTML(act) : '') + '</div><div data-sp-garage-picker' + (act ? ' hidden' : '') + '></div>';
      var pk = buildPicker(m.querySelector('[data-sp-garage-picker]'), { saveText: m.dataset.saveText || 'Show my exhaust', onSave: function (b) { window.location.href = shopUrl(b); } });
      m.addEventListener('click', function (e) { if (e.target.closest('[data-sp-garage-change]')) { e.preventDefault(); m.querySelector('[data-sp-garage-result]').innerHTML = ''; var p = m.querySelector('[data-sp-garage-picker]'); p.hidden = false; pk.reset(); } });
    });
    renderTiles();
    renderKits();
    renderCartKits();
    renderProfileCtas();
    function resultHTML(b) {
      var r = findGen(b.genId);
      var one = r && (r.gen.systems.length + r.gen.slipons.length) === 1;
      var others = ordered().filter(function (x) { return x.id !== b.id; });
      return '<div class="sp-garage-result"><p class="sp-garage-result__bike">' + ICON.tick + 'Your bike: <strong>' + esc(label(b)) + '</strong> <button type="button" data-sp-garage-change>change</button></p>' +
        '<a class="btn" href="' + shopUrl(b) + '">' + (one ? (r.gen.systems.length ? 'See the system built for it' : 'See the slip-on built for it') : 'See what fits it') + '</a>' +
        (others.length ? '<p class="sp-garage-result__more">' + others.map(function (x) { return '<a href="' + shopUrl(x) + '" data-sp-kf-click="finder">Shop for my ' + esc(name(x)) + '</a>'; }).join('') + '</p>' : '') + '</div>';
    }
  }

  function renderFitment(el) {
    var r = fits(el.dataset.handle, el.dataset.type);
    var fallback = el.dataset.fallback || '';
    var html = '';
    var nb2, o;
    el.className = 'sp-fitment sp-fitment--' + r.status;
    if (r.status === 'model') {
      var sec = el.closest('[data-section-type="product"]') || document;
      var mv = modelVerdict(sec, el.dataset.handle, r);
      var noun = partNoun(el.dataset.handle);
      if (mv.state === 'fits') {
        el.className = 'sp-fitment sp-fitment--fits';
        html = ICON.tick + '<div><strong>Fits your ' + esc(label(mv.bike)) + '</strong><span>Model ' + esc(mv.want) + ' is selected' + (mv.auto ? ' for you' : '') + '.</span></div>';
      } else if (mv.state === 'wrong_model') {
        el.className = 'sp-fitment sp-fitment--no_fit';
        html = ICON.info + '<div><strong>This Model is for ' + esc(mv.sel || 'another bike') + ', not your ' + esc(label(mv.bike)) + '</strong><span><button type="button" data-sp-pick-model="' + esc(mv.want) + '">Select ' + esc(mv.want) + '</button></span></div>';
      } else {
        el.className = 'sp-fitment sp-fitment--no_fit';
        html = ICON.info + '<div><strong>We do not make this ' + esc(noun) + ' for your ' + esc(label(mv.bike)) + '</strong><span><a href="' + shopUrl(mv.bike) + '">Shop parts for my ' + esc(label(mv.bike)) + '</a> or <button type="button" data-sp-garage-open>change bike</button></span>' +
          (mv.other ? '<span>It is made for your ' + esc(label(mv.other)) + '. <button type="button" data-sp-set-active="' + esc(mv.other.id) + '">Select it for my ' + esc(name(mv.other)) + '</button></span>' : '') + '</div>';
      }
    } else if (r.status === 'fits') {
      var part = r.k && r.k.part;
      var strong = 'Fits your ' + esc(label(r.bike));
      var note = '';
      if (part && part.model && r.bike.model !== part.model) note = '<span>For ' + esc(part.fitLabel) + '.</span>';
      else if (part && part.note) note = '<span>' + esc(part.note) + '</span>';
      else if (r.gen && r.gen.note && r.k.kind === 'own') note = '<span>' + esc(r.gen.note) + '</span>';
      else if (fallback && r.k.kind === 'own') note = '<span>' + esc(fallback) + '</span>';
      html = ICON.tick + '<div><strong>' + strong + '</strong>' + note +
        (r.other ? '<span>Your active bike is the ' + esc(label(api.active())) + '. <button type="button" data-sp-set-active="' + esc(r.bike.id) + '">Make the ' + esc(label(r.bike)) + ' my active bike</button></span>' : '') + '</div>';
    } else if (r.status === 'universal' && (r.headerless || r.notOffered)) {
      el.className = 'sp-fitment sp-fitment--no_fit';
      nb2 = r.headerless || r.notOffered;
      html = ICON.info + '<div><strong>' + (r.headerless ? 'Bolts to a Stealth header, which your ' + esc(label(nb2)) + ' does not use' : 'The Stealth system for your ' + esc(label(nb2)) + ' is not built with the ' + esc(r.muffler)) + '</strong>' +
        '<span><a href="' + shopUrl(nb2) + '">Shop parts for my ' + esc(label(nb2)) + '</a> or <button type="button" data-sp-garage-open>change bike</button></span>' +
        (r.other ? '<span>It fits the Stealth header on your ' + esc(label(r.other)) + '. <button type="button" data-sp-set-active="' + esc(r.other.id) + '">Make it my active bike</button></span>' : '') + '</div>';
    } else if (r.status === 'universal') {
      html = ICON.tick + '<div><strong>Fits every Stealth header' + (r.bike ? ', including your ' + esc(label(r.bike)) : '') + '</strong>' + (r.slipon ? '<span>2.25 inch slip-on. Works with most other 2.25 inch headers too.</span>' : '') + '</div>';
    } else if (r.status === 'wrong_year') {
      el.className = 'sp-fitment sp-fitment--no_fit';
      html = ICON.info + '<div><strong>Built for ' + esc(r.fitLabel) + ', not your ' + esc(label(r.bike)) + '</strong><span><a href="' + shopUrl(r.bike) + '">See what fits your ' + esc(label(r.bike)) + '</a> or <button type="button" data-sp-garage-open>change bike</button></span></div>';
    } else if (r.status === 'no_fit') {
      html = ICON.info + '<div><strong>Built for ' + esc(r.fitLabel) + ', not for ' + (r.many ? 'any of your saved bikes' : 'your ' + esc(label(r.bike))) + '</strong><span><a href="' + shopUrl(r.bike) + '">See what fits your ' + esc(label(r.bike)) + '</a> or <button type="button" data-sp-garage-open>change bike</button></span></div>';
    } else if (r.status === 'no_bike') {
      o = r.fitLabel;
      html = ICON.bike + '<div><strong>Built for ' + esc(o) + '</strong><span><button type="button" data-sp-garage-open>Add your bike</button> to confirm fitment on every page.</span></div>';
    } else {
      if (!fallback) { el.hidden = true; return; }
      html = ICON.tick + '<div><strong>' + esc(fallback) + '</strong></div>';
    }
    el.hidden = false;
    el.innerHTML = html;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sp-pick-model]');
    if (!b) return;
    e.preventDefault();
    var sec = b.closest('[data-section-type="product"]') || document;
    delete sec.dataset.spModelTouched;
    pickModel(sec, b.getAttribute('data-sp-pick-model'));
    setTimeout(function () { var f = sec.querySelector('[data-sp-fitment]'); if (f) { f.setAttribute('tabindex', '-1'); f.focus({ preventScroll: true }); } }, 30);
  });

  /* ----- Bike finder tiles: the saved bike's tile is marked "Yours" in place (no reorder, no shift).
     Match on data-gen (sp2-tiles' sp-bike-photo), else on the tile link's collection. ----- */
  function renderTiles() {
    var tiles = document.querySelectorAll('.sp-finder__tile');
    if (!tiles.length) return;
    var bikes = api.list();
    var gens = bikes.map(function (b) { return b.genId; });
    var cols = bikes.map(function (b) { var r = findGen(b.genId); return r ? '/collections/' + r.gen.collection : ''; });
    tiles.forEach(function (t) {
      var a = t.querySelector('a');
      var g = t.querySelector('[data-gen]');
      var mine = (g && gens.indexOf(g.getAttribute('data-gen')) > -1) || (a && cols.indexOf(a.pathname.replace(/\/$/, '')) > -1);
      t.classList.toggle('sp-kf-yours', !!mine);
      var tag = t.querySelector('[data-sp-kf-yours]');
      if (mine && !tag) {
        var host = t.querySelector('.sp-finder__tile-media') || t;
        host.insertAdjacentHTML('beforeend', '<span class="sp-kf-yours-tag" data-sp-kf-yours>Yours</span>');
      } else if (!mine && tag) tag.remove();
    });
  }

  /* ======================================================================
     Complete the system (kit builder), 2026-09-09
     A universal 2.25 inch slip-on bolts to a Stealth header, not stock pipes. When a rider lands
     on a muffler first, this offers the FULL SYSTEM for their bike with that muffler already
     selected (finish and badge follow the muffler picker), one tap to cart. The same logic guards
     the cart: a universal slip-on with no header in the cart gets a swap offer.
     ====================================================================== */
  var productCache = {};
  function fetchProduct(handle) {
    if (!productCache[handle]) productCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('nf'); return r.json(); });
    return productCache[handle];
  }
  function money(cents) {
    var fmt = (window.theme && theme.settings && theme.settings.moneyFormat) || '${{amount}}';
    var val = (Math.abs(cents) / 100).toFixed(2).split('.');
    val[0] = val[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = fmt.indexOf('no_decimals') > -1 ? val[0] : val.join('.');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, out).replace(/<[^>]+>/g, '');
  }
  /* Dealer-aware price (Wholesale Gorilla rules, snippets/sp-dealer-price.liquid). Retail: unchanged. */
  function kitPrice(v, p) {
    var c = window.SP && SP.dealerPrice ? SP.dealerPrice(v.price, p && p.id, v.id) : v.price;
    return c === null ? '' : money(c);
  }
  function finishKey(str) { var t = (str || '').toLowerCase(); if (t.indexOf('polish') > -1) return 'polished'; if (t.indexOf('cerakote') > -1 || t.indexOf('black') > -1) return 'black'; return 'raw'; }
  function badgeKey(str) { var t = (str || '').toLowerCase(); if (!t) return null; if (t.indexOf('no badge') > -1 || t === 'no') return 'no'; if (t.indexOf('custom') > -1) return 'custom'; if (t.indexOf('badge') > -1 || t === 'yes') return 'yes'; return null; }
  function optIndex(p, re) { for (var i = 0; i < (p.options || []).length; i++) { var n = typeof p.options[i] === 'string' ? p.options[i] : p.options[i].name; if (re.test(n || '')) return i; } return -1; }
  function pickVariant(p, want) {
    var iM = optIndex(p, /muffler/i), iF = optIndex(p, /finish|color/i), iB = optIndex(p, /badge/i), iMo = optIndex(p, /model/i);
    var cands = (p.variants || []).filter(function (v) {
      if (want.muffler && iM > -1 && !want.muffler.test((v.options[iM] || '').toLowerCase())) return false;
      if (want.model && iMo > -1 && v.options[iMo] !== want.model) return false;
      return true;
    });
    if (!cands.length) return null;
    var score = function (v) { var sc = 0; if (iF > -1 && finishKey(v.options[iF]) === want.finish) sc += 2; if (iB > -1 && want.badge && badgeKey(v.options[iB]) === want.badge) sc += 1; if (iB > -1 && !want.badge && badgeKey(v.options[iB]) === 'yes') sc += 1; if (v.available) sc += 4; return sc; };
    cands.sort(function (a, b) { return score(b) - score(a); });
    return { variant: cands[0], iF: iF, iB: iB, iM: iM };
  }
  /* What is selected on the muffler PDP right now (finish + badge), so the system matches it. */
  function pdpSelection(el) {
    var section = el.closest('[data-section-type="product"]');
    var vals = [];
    if (section) section.querySelectorAll('[data-variant-input]').forEach(function (i) { if (i.tagName === 'SELECT') vals.push(i.value); else if (i.checked) vals.push(i.value); });
    var joined = vals.join(' | ');
    var badge = null;
    vals.forEach(function (v) { var b = badgeKey(v); if (b) badge = b; });
    return { finish: finishKey(joined), badge: badge, values: vals };
  }
  function selectionFromOptions(str) { var b = null; String(str || '').split(/\s*\/\s*/).forEach(function (v) { var k = badgeKey(v); if (k) b = k; }); return { finish: finishKey(str), badge: b }; }
  function finishLabel(v, iF) { return iF > -1 ? v.options[iF] : ''; }
  function badgeLabel(v, iB) { if (iB < 0) return ''; var b = badgeKey(v.options[iB]); return b === 'no' ? 'no badge' : b === 'custom' ? 'Custom badge' : 'Stealth badge'; }
  /* A Custom Badge line carries its artwork URL and notes as line item properties (CR-01). The swap can only move
     them if the cart line has them; underscore keys stay behind (Shopify private properties). */
  function carryProps(item) {
    var out = {}, n = 0, props = item && item.properties;
    if (!props || typeof props !== 'object') return null;
    /* Accept [key, value] pairs too (Liquid's json filter on a properties hash), never numeric keys */
    if (Array.isArray(props) || Object.keys(props).every(function (k) { return /^\d+$/.test(k) && Array.isArray(props[k]); })) {
      var o = {}; Object.keys(props).forEach(function (k) { var pr = props[k]; if (Array.isArray(pr) && pr.length === 2) o[pr[0]] = pr[1]; }); props = o;
    }
    Object.keys(props).forEach(function (k) { if (k.charAt(0) !== '_' && props[k] !== null && props[k] !== '') { out[k] = props[k]; n++; } });
    return n ? out : null;
  }
  function customLink(gen, sysHandle, conf) {
    return '<a href="/products/' + sysHandle + '?sp_muffler=' + encodeURIComponent(conf.name) + '#sp-muffler">Get the ' + esc(gen.label) + ' system with your custom badge on its page</a>. You will upload the artwork there.';
  }

  function offerHTML(o) {
    /* o: { lead, img, name, sub, price, btnText, btnAttr, alt } */
    return '<p class="sp-kit__lead">' + o.lead + '</p>' +
      '<div class="sp-kit__offer">' + (o.img ? '<img class="sp-kit__img" src="' + o.img + '" alt="" width="56" height="56" loading="lazy">' : '<span class="sp-kit__img" aria-hidden="true"></span>') +
      '<div class="sp-kit__meta"><span class="sp-kit__name">' + o.name + '</span><span class="sp-kit__sub">' + o.sub + '</span></div>' +
      '<span class="sp-kit__price">' + o.price + '</span></div>' +
      '<button type="button" class="btn sp-kit__btn" ' + o.btnAttr + '>' + esc(o.btnText) + '</button>' +
      '<p class="sp-kit__alt">' + o.alt + '</p>';
  }
  function imgSrc(p) { var u = (p.featured_image || (p.images && p.images[0]) || ''); if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=112&height=112&crop=center'; }

  function renderKit(el) {
    if (!K) { el.hidden = true; return; }
    var conf = K.mufflers[el.dataset.handle];
    if (!conf) { el.hidden = true; return; }
    var body = el.querySelector('[data-sp-kit-body]');
    var act = api.active();
    var cta = el.dataset.cta || 'Add the full system to cart';
    var section = el.closest('[data-section-type="product"]');
    if (section && !section.dataset.spKitHook) {
      section.dataset.spKitHook = '1';
      section.addEventListener('change', function (e) { if (e.target.matches('[data-variant-input]')) setTimeout(function () { renderKit(el); }, 0); });
      section.addEventListener('variantChange', function () { renderKit(el); });
    }
    if (!act) {
      if (el.dataset.mode === 'picker') return;
      el.dataset.mode = 'picker';
      body.innerHTML = '<p class="sp-kit__lead">Slip-ons bolt to a Stealth header, not stock pipes. Pick your bike and we build the full system with the ' + esc(conf.name) + ' already on it. One part number, free US shipping.</p><div data-sp-kit-picker></div><p class="sp-kit__alt">Already running Stealth headers? Add just the muffler above.</p>';
      buildPicker(body.querySelector('[data-sp-kit-picker]'), { saveText: 'Show my system' });
      return;
    }
    el.dataset.mode = 'bike';
    var r = findGen(act.genId), gen = r && r.gen;
    var change = ' <button type="button" data-sp-garage-open>change bike</button>';
    var changeCap = ' <button type="button" data-sp-garage-open>Change bike</button>'; /* after a full stop (CR-17) */
    if (conf.gens && gen && conf.gens.indexOf(gen.id) < 0) {
      body.innerHTML = '<p class="sp-kit__lead">The ' + esc(conf.name) + ' is built for baggers, not your ' + esc(label(act)) + '. <a href="' + shopUrl(act) + '">See the system built for your bike</a> or' + change + '.</p>';
      return;
    }
    if (!gen || !gen.systems.length) {
      if (gen && gen.slipons.length) body.innerHTML = '<p class="sp-kit__lead">Your ' + esc(label(act)) + ' runs a slip-on of its own, so this universal muffler is not the one for it. <a href="/products/' + gen.slipons[0] + '">See the ' + esc(gen.label) + ' slip-on</a> or' + change + '.</p>';
      else body.innerHTML = '<p class="sp-kit__lead">We do not build a header for your ' + esc(label(act)) + ' yet. This slip-on fits any 2.25 inch header.' + changeCap + '</p>';
      return;
    }
    /* XG and Monkey systems are complete platform builds with no Muffler option: same verdict as the PDP chip */
    if (!takesHeader(act)) {
      body.innerHTML = '<p class="sp-kit__lead">Your ' + esc(label(act)) + ' runs its own <a href="/products/' + gen.systems[0] + '">' + esc(gen.label) + ' system</a>, which does not use a Stealth 2.25 inch header, so this muffler does not bolt to it.' + changeCap + '</p>';
      return;
    }
    var sel = pdpSelection(el);
    var sysHandle = gen.systems[0];
    if (el.dataset.mode !== 'bike' || !body.querySelector('.sp-kit__offer')) body.innerHTML = '<p class="sp-kit__lead">Checking the system for your ' + esc(label(act)) + '.</p>';
    var seq = (el.dataset.seq = String((+el.dataset.seq || 0) + 1));
    fetchProduct(sysHandle).then(function (p) {
      if (el.dataset.seq !== seq) return;
      var re = conf.match ? new RegExp(conf.match, 'i') : null;
      var pv = re ? pickVariant(p, { muffler: re, finish: sel.finish, badge: sel.badge }) : null;
      /* Custom Badge: the artwork is a file input on the system page and cannot travel in a JSON add (CR-01) */
      if (sel.badge === 'custom' && pv && pv.variant) {
        body.innerHTML = '<p class="sp-kit__lead"><strong>Your ' + esc(label(act)) + ' runs the ' + esc(p.title) + '.</strong> ' + customLink(gen, sysHandle, conf) + changeCap + '</p>';
        return;
      }
      if (pv && pv.variant) {
        var v = pv.variant;
        var fin = finishLabel(v, pv.iF);
        var badgeTxt = badgeLabel(v, pv.iB);
        body.innerHTML = offerHTML({
          lead: '<strong>Your ' + esc(label(act)) + ' runs the ' + esc(p.title) + '.</strong> Add it with the ' + esc(conf.name) + ' already on it and you are done.',
          img: imgSrc(p),
          name: 'Full system with the ' + esc(conf.name),
          sub: esc([fin, badgeTxt].filter(Boolean).join(', ')) + '. Header, muffler and hardware. Free US shipping.',
          price: kitPrice(v, p),
          btnText: v.available ? cta : 'Sold out',
          btnAttr: 'data-sp-kit-add="' + v.id + '" data-sp-kit-name="' + esc(p.title) + '"' + (v.available ? '' : ' disabled'),
          alt: 'One part number, this muffler included. Already running Stealth headers? Add just the muffler above.' + changeCap
        });
        return;
      }
      var model = K.headerModelByGen && K.headerModelByGen[gen.id];
      if (model && K.headerProduct) {
        return fetchProduct(K.headerProduct).then(function (h) {
          if (el.dataset.seq !== seq) return;
          var hv = pickVariant(h, { model: model, finish: sel.finish });
          if (!hv || !hv.variant) throw new Error('no header');
          var v2 = hv.variant;
          body.innerHTML = offerHTML({
            lead: '<strong>Your ' + esc(label(act)) + ' needs the ' + esc(model) + ' header for this muffler.</strong> Add the header, keep the ' + esc(conf.name) + ' above, and you have the full system.',
            img: imgSrc(h),
            name: esc(h.title) + ', ' + esc(model),
            sub: esc(finishLabel(v2, hv.iF)) + '. Pairs with the ' + esc(conf.name) + '.',
            price: kitPrice(v2, h),
            btnText: v2.available ? 'Add the header to cart' : 'Sold out',
            btnAttr: 'data-sp-kit-add="' + v2.id + '" data-sp-kit-name="' + esc(h.title) + '"' + (v2.available ? '' : ' disabled'),
            alt: 'Already running Stealth headers? Add just the muffler above.' + changeCap
          });
        });
      }
      /* The system exists but does not offer this muffler (Sportster S has no Mid-Length Pipe Bomb, audit X03) */
      var iM = optIndex(p, /muffler/i);
      if (iM > -1) {
        var offered = [];
        p.variants.forEach(function (v) { var n = String(v.options[iM]).replace(/\s*\(.*\)\s*$/, '').replace(/ muffler$/i, ''); if (offered.indexOf(n) < 0) offered.push(n); });
        body.innerHTML = '<p class="sp-kit__lead">Your ' + esc(label(act)) + ' runs the <a href="/products/' + sysHandle + '">' + esc(p.title) + '</a>. It is not built with the ' + esc(conf.name) + '; it takes the ' + esc(offered.join(', ')) + '.' + changeCap + '</p>';
        return;
      }
      throw new Error('no match');
    }).catch(function () {
      if (el.dataset.seq !== seq) return;
      body.innerHTML = '<p class="sp-kit__lead">Your ' + esc(label(act)) + ' runs the <a href="/products/' + sysHandle + '">' + esc(gen.label) + ' full system</a>. Pick this muffler on that page and it ships as one system.' + changeCap + '</p>';
    });
  }
  function renderKits() { document.querySelectorAll('[data-sp-kit]').forEach(renderKit); }

  /* ---------- cart safety net ---------- */
  var cartState = null;
  function isUniversalSlipOn(item) { return item.product_type === 'Slip-On Mufflers' && !/oem-fit|pan-america/.test(item.handle) && K && !!K.mufflers[item.handle]; }
  function hasHeader(cart) { return cart.items.some(function (i) { return i.product_type === 'Full Exhaust Systems' || (K && i.handle === K.headerProduct); }); }
  function renderCartKits() {
    var mounts = document.querySelectorAll('[data-sp-cart-kit]');
    if (!mounts.length || !K) return;
    var draw = function (cart) {
      var orphans = cart && !hasHeader(cart) ? cart.items.filter(isUniversalSlipOn) : [];
      mounts.forEach(function (m) {
        /* CR-02: a mount inside a cart line draws that line only (its own system, badge and properties), so Swap
           removes the line it sits under. The legacy mount outside the lines (cart-addons) takes the first orphan. */
        var ln = m.closest('[data-cd-line]');
        var orphan = ln ? orphans.filter(function (i) { return i.key === ln.dataset.key; })[0] : orphans[0];
        if (!orphan) { m.hidden = true; m.innerHTML = ''; m.dataset.mode = ''; m.dataset.sig = ''; return; }
        var conf = K.mufflers[orphan.handle];
        var act = api.active();
        m.hidden = false;
        /* CR-06: both answers live in the card. In a cart line the card carries "I run Stealth headers" (the drawer's
           own handler, data-cd-hdr-ok) and a one-sentence lead; the legacy mount keeps its longer copy. */
        var lead1 = 'On stock pipes? The ' + esc(conf.name) + ' does not bolt to stock pipes.'; /* D11: it also fits other 2.25 inch headers, so never "needs a Stealth header" */
        var hdr = ln ? '<p class="sp-kit__hdr"><button type="button" class="sp-cd__link" data-cd-hdr-ok>I run Stealth headers</button></p>' : '';
        var changeCap = ' <button type="button" data-sp-garage-open>Change bike</button>';
        if (!act) {
          if (m.dataset.mode === 'picker' && m.dataset.key === orphan.key) return;
          m.dataset.mode = 'picker'; m.dataset.key = orphan.key; m.dataset.sig = '';
          m.innerHTML = '<div class="sp-kit sp-kit--cart"><p class="sp-kit__eyebrow">Heads up</p><p class="sp-kit__lead">' + lead1 + ' Pick your bike and we swap in the full system.' + (ln ? '' : ' Already on Stealth headers? You are set.') + '</p><div data-sp-kit-picker></div>' + hdr + '</div>';
          buildPicker(m.querySelector('[data-sp-kit-picker]'), { saveText: 'Show my system' });
          return;
        }
        /* D11 (CR-03 d): the same line, bike and badge draw the same card. Skip the redraw (the /cart.js read after
           "Show my system" used to replace the offer and drop the focus it had just been given). */
        var sig = [orphan.key, orphan.variant_id, act.genId, act.year, JSON.stringify(orphan.properties || {}), window.wsgDataReady ? 'wsg' : ''].join('|');
        if (m.dataset.mode === 'bike' && m.dataset.sig === sig && m.innerHTML.trim()) return;
        m.dataset.sig = sig;
        m.dataset.mode = 'bike'; m.dataset.key = orphan.key;
        var r = findGen(act.genId), gen = r && r.gen;
        var change = ' <button type="button" data-sp-garage-open>change bike</button>';
        if (!gen || !gen.systems.length || (conf.gens && conf.gens.indexOf(gen.id) < 0)) {
          m.innerHTML = '<div class="sp-kit sp-kit--cart"><p class="sp-kit__eyebrow">Heads up</p><p class="sp-kit__lead">' + lead1 + (ln ? '' : ' Already on Stealth headers? You are set.') + ' <a href="' + shopUrl(act) + '">See what fits your ' + esc(label(act)) + '</a> or' + change + '.</p>' + hdr + '</div>';
          return;
        }
        var sel = selectionFromOptions(orphan.variant_title || (orphan.variant_options || []).join(' / '));
        var sysHandle = gen.systems[0];
        if (m.contains(document.activeElement)) m.dataset.wantFocus = '1'; /* CR-03: "Show my system" was pressed in here */
        m.innerHTML = '<div class="sp-kit sp-kit--cart"><p class="sp-kit__eyebrow">Heads up</p><p class="sp-kit__lead">Checking the system for your ' + esc(label(act)) + '.</p></div>';
        var refocus = function () { if (m.dataset.wantFocus !== '1') return; m.dataset.wantFocus = ''; var f = m.querySelector('[data-sp-kit-swap], a, [data-cd-hdr-ok]'); if (f) f.focus(); };
        fetchProduct(sysHandle).then(function (p) {
          var pv = conf.match ? pickVariant(p, { muffler: new RegExp(conf.match, 'i'), finish: sel.finish, badge: sel.badge }) : null;
          if (!pv || !pv.variant) throw new Error('no match');
          var v = pv.variant;
          /* Custom Badge muffler (CR-01): swap only to the Custom Badge system and only when the artwork and notes
             can ride along as properties; otherwise send the rider to the system page to upload there. */
          var props = null;
          if (sel.badge === 'custom') {
            props = carryProps(orphan);
            if (!props || pv.iB < 0 || badgeKey(v.options[pv.iB]) !== 'custom') {
              m.innerHTML = '<div class="sp-kit sp-kit--cart"><p class="sp-kit__eyebrow">Heads up</p><p class="sp-kit__lead">' + lead1 + ' ' + customLink(gen, sysHandle, conf) + changeCap + '</p>' + hdr + '</div>';
              refocus();
              return;
            }
          }
          m.innerHTML = '<div class="sp-kit sp-kit--cart"><p class="sp-kit__eyebrow">Heads up</p>' + offerHTML({
            lead: ln ? lead1 : 'The ' + esc(conf.name) + ' bolts to a Stealth header, not stock pipes. Is your ' + esc(label(act)) + ' on stock pipes? Swap it for the full system with the ' + esc(conf.name) + ' included.',
            img: imgSrc(p), name: esc(p.title), sub: esc([finishLabel(v, pv.iF), conf.name, props ? badgeLabel(v, pv.iB) + ', your artwork comes along' : ''].filter(Boolean).join(', ')) + '. Free US shipping.', price: kitPrice(v, p),
            btnText: v.available ? 'Swap for the full system' : 'Sold out',
            btnAttr: 'data-sp-kit-swap="' + v.id + '" data-sp-kit-key="' + esc(orphan.key) + '"' + (props ? ' data-sp-kit-props="' + esc(JSON.stringify(props)) + '"' : '') + (v.available ? '' : ' disabled'),
            alt: ln ? changeCap.trim() : 'Already on Stealth headers? Ignore this, the muffler alone is right.' + changeCap
          }) + hdr + '</div>';
          refocus();
        }).catch(function () {
          m.innerHTML = '<div class="sp-kit sp-kit--cart"><p class="sp-kit__eyebrow">Heads up</p><p class="sp-kit__lead">' + lead1 + ' <a href="/products/' + sysHandle + '">Get the ' + esc(gen.label) + ' full system</a> with this muffler selected instead.' + changeCap + '</p>' + hdr + '</div>';
          refocus();
        });
      });
    };
    if (cartState) draw(cartState);
    /* The cart drawer (sp2-drawer) sends the cart with every cart:updated from its Section Rendering response:
       draw from it and skip /cart.js while it is fresh (2 s), part of the 2026-10-03 429 fix. */
    if (cartState && Date.now() - cartAt < 2000) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { cartState = c; cartAt = Date.now(); draw(c); }).catch(function () {});
  }
  var cartAt = 0;
  function cartStale() { if (Date.now() - cartAt >= 2000) cartState = null; renderCartKits(); }
  document.addEventListener('cart:updated', function (e) { if (e.detail && e.detail.cart) { cartState = e.detail.cart; cartAt = Date.now(); } renderCartKits(); });
  /* Wholesale Gorilla dealer rules arrive after load (snippets/sp-dealer-price.liquid): redraw kit prices. */
  document.addEventListener('sp:dealer-ready', function () { renderKits(); cartState = null; renderCartKits(); });
  ['ajaxProduct:added', 'cart:build', 'cart:open', 'cart:quantity'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(cartStale, 400); }); });
  /* Impulse rebuilds the drawer's line items in place without an event we can trust everywhere; watch the DOM too. */
  (function watchDrawer() {
    var host = document.querySelector('#CartDrawer [data-products], .cart__page [data-products], form[data-location="cart-page"]');
    if (!host || !('MutationObserver' in window)) return;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(cartStale, 250); }).observe(host, { childList: true, subtree: true });
  })();

  /* ---------- add / swap actions ---------- */
  function cartPost(url, payload) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json(); }).then(function (d) { if (d && d.status && d.status !== 200) throw new Error(d.description || 'error'); return d; });
  }
  function routes() { return (window.theme && theme.routes) || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js' }; }
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-sp-kit-add]');
    var swap = e.target.closest('[data-sp-kit-swap]');
    var btn = add || swap;
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    var original = btn.textContent;
    /* CR-03: busy, not disabled, so focus stays on the button; the drawer then focuses the new system line */
    btn.setAttribute('aria-busy', 'true'); btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Adding\u2026';
    var unbusy = function () { btn.removeAttribute('aria-busy'); btn.removeAttribute('aria-disabled'); };
    /* Swap = add the system first, remove the muffler only once the add worked. If the add fails (429, stock,
       offline) the muffler stays and the cart's status line says so (WDG JS review 2026-10-05). */
    var status = function (msg) {
      /* Right under the button the rider pressed; the cart's status line (below the lines, often off screen) only when
         the button sits outside a card. */
      var card = btn.parentNode;
      if (card) {
        var err = card.querySelector('.sp-kit__err');
        if (!err) { err = document.createElement('p'); err.className = 'sp-kit__err'; err.setAttribute('role', 'alert'); btn.insertAdjacentElement('afterend', err); }
        err.textContent = msg;
        return;
      }
      var st = (btn.closest('[data-sp-cd]') || document).querySelector('[data-cd-status]');
      if (st) { st.textContent = msg; st.hidden = false; }
    };
    var added = false;
    var payload = { id: btn.dataset.spKitAdd || btn.dataset.spKitSwap, quantity: 1 };
    if (btn.dataset.spKitProps) { try { payload.properties = JSON.parse(btn.dataset.spKitProps); } catch (err) { unbusy(); btn.textContent = original; status('We could not move your artwork. Open the system page to upload it there.'); return; } }
    cartPost(routes().cartAdd, payload)
      .then(function () {
        added = true;
        if (swap && btn.dataset.spKitKey) return cartPost(routes().cartChange, { id: btn.dataset.spKitKey, quantity: 0 }).catch(function () {
          status('The full system is in your cart. Your muffler is still there too. Remove it if you do not need it.');
        });
      })
      .then(function () {
        btn.textContent = 'Added'; unbusy();
        window.SP = window.SP || {}; SP.cdFocus = '[data-variant="' + payload.id + '"] .sp-cd__name';
        try { var k = window.klaviyo || window._learnq; if (k && k.push) k.push(['track', swap ? 'Swapped Muffler For System' : 'Added System From Muffler', { VariantId: btn.dataset.spKitAdd || btn.dataset.spKitSwap, Bike: api.active() ? label(api.active()) : '' }]); } catch (err) {}
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        setTimeout(renderCartKits, 400);
      })
      .catch(function () {
        unbusy(); btn.textContent = original;
        if (!added) status(swap ? 'We could not add the full system. Your muffler is still in the cart. Try again.' : 'We could not add the full system. Try again.');
      });
  });

  /* ---------- sound profile CTAs follow the bike ---------- */
  /* A card only deep-links when the bike's system sells that profile's muffler (audit X03: Sportster S has
     no Mid-Length Pipe Bomb; XG and Monkey have no Muffler option). Until the check returns, and when it
     fails, the card keeps its default link to the profile collection. */
  function renderProfileCtas() {
    var act = api.active();
    var r = act ? findGen(act.genId) : null, gen = r && r.gen;
    var sys = gen && gen.systems.length === 1 && K ? gen.systems[0] : null;
    var ctas = document.querySelectorAll('[data-sp-profile-cta]');
    var notes = document.querySelectorAll('[data-sp-profiles-bike]');
    if (!ctas.length && !notes.length) return;
    var seq = (renderProfileCtas.seq = (renderProfileCtas.seq || 0) + 1);
    function paint(matches) {
      var linked = 0;
      ctas.forEach(function (a) {
        var t = a.querySelector('[data-sp-profile-cta-text]');
        var lvl = a.dataset.spProfileCta;
        if (matches && matches[lvl]) {
          linked++;
          a.href = '/products/' + sys + '?sp_muffler=' + encodeURIComponent(K.profileDefault[lvl]) + '#sp-muffler';
          if (t) t.textContent = 'Build it for my ' + label(act);
        } else {
          a.href = a.dataset.defaultHref;
          if (t) t.textContent = a.dataset.defaultText;
        }
      });
      notes.forEach(function (p) {
        p.hidden = false;
        if (sys && linked) p.innerHTML = 'Each linked profile opens the ' + esc(gen.label) + ' full system with that muffler already selected. <button type="button" data-sp-garage-open>Change bike</button>';
        else if (act) p.innerHTML = 'Every muffler bolts to a Stealth header. <a href="' + shopUrl(act) + '">See what fits your ' + esc(label(act)) + '</a>.';
        else p.innerHTML = 'Every muffler bolts to a Stealth header. <button type="button" data-sp-garage-open>Add your bike</button> and each profile links straight to the full system built for it.';
      });
    }
    paint(null);
    if (!sys || !K.profileDefault) return;
    fetchProduct(sys).then(function (p) {
      if (renderProfileCtas.seq !== seq) return;
      var iM = optIndex(p, /muffler/i);
      if (iM < 0) return;
      var matches = {};
      Object.keys(K.profileDefault).forEach(function (lvl) {
        var re = new RegExp(K.profileDefault[lvl], 'i');
        matches[lvl] = (p.variants || []).some(function (v) { return re.test((v.options[iM] || '').toLowerCase()); });
      });
      paint(matches);
    }).catch(function () {});
  }


  /* ======================================================================
     Known fit across the lists (round 2 item 7), 2026-10-03
     Design: Strategy/2026-10/known-fit/Known-Fit-Design-2026-10-03.md (coordinator rulings 1 to 8).
     With a bike saved, every list leads with what fits it, says so at the top, hides only what is known not to
     fit (another platform, other years, or a Stealth header the bike does not use), and keeps Show all one tap
     away (remembered per surface for the session). Apparel and generic parts stay, after the fits.
     Zero guard: when nothing in a list is built for the saved bikes, nothing is hidden.
     Everything runs in the browser from the vocab: the server HTML, its links and URLs never change; cards are
     moved and hidden, never cloned, and Show all restores the server order. Dealers get chips only.
     Surfaces: collection and search ([data-sp-kf-banner]), rows ([data-sp-kf="row"]: home, landing, 404 and empty
     search), PDP related (Impulse product-recommendations), card chips everywhere (recently viewed included).
     ====================================================================== */
  var KF_ALL = 'sp_kf_all:';
  var KF_IDX = 'sp_kf_idx:';
  function kfAll(s) { try { return window.sessionStorage.getItem(KF_ALL + s) === '1'; } catch (e) { return false; } }
  function kfSetAll(s, on) { try { if (on) window.sessionStorage.setItem(KF_ALL + s, '1'); else window.sessionStorage.removeItem(KF_ALL + s); } catch (e) {} }
  /* Family names a search query mentions, from the vocab ("dyna", "softail", "nightster", "pan america") */
  var FAM_STOP = ['harley', 'davidson', 'street', 'evo', 'twin', 'cam', 'rubber', 'mount', 'revolution', 'max', 'and', '500', '750', '125'];
  function queryFamilies(q) {
    var words = q.split(/[^a-z0-9]+/);
    var out = [];
    V.makes.forEach(function (m) { m.families.forEach(function (f) { f.generations.forEach(function (g) {
      var toks = (f.name + ' ' + (g.short || '')).toLowerCase().split(/[^a-z0-9]+/).filter(function (t) { return t.length > 2 && FAM_STOP.indexOf(t) < 0; });
      if (toks.some(function (t) { return words.indexOf(t) > -1; }) && out.indexOf(f.name) < 0) out.push(f.name);
    }); }); });
    return out;
  }
  var KF_Q = 'sp_kf_q:';
  function kfQ(q) { if (!q) return ''; try { return window.sessionStorage.getItem(KF_Q + q) || ''; } catch (e) { return ''; } }
  /* One saved bike picked for a surface (Collection V3 bike chips: one tap = that bike, second tap = all). Session. */
  var KF_SEL = 'sp_kf_sel:';
  function kfSel(s) { try { return window.sessionStorage.getItem(KF_SEL + s) || ''; } catch (e) { return ''; } }
  function kfSetSel(s, id) { try { if (id) window.sessionStorage.setItem(KF_SEL + s, id); else window.sessionStorage.removeItem(KF_SEL + s); } catch (e) {} }
  /* A new or switched bike starts every surface in fit mode again, with every bike */
  function kfClearAll() { ['collection', 'search', 'home_row', 'pdp_related'].forEach(function (s) { kfSetAll(s, false); kfSetSel(s, ''); }); }
  /* Customer Events pixel forwards these to GA4 (same helper as sp-reviews.js) */
  function publish(n, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(n, data); } catch (e) {} }
  function isDealer() { return !!(window.SP && SP.isDealer && SP.isDealer()); }
  function plural(n, w) { return n === 1 ? w : w + 's'; }
  function joinOr(list) { return list.length < 2 ? list.join('') : list.slice(0, -1).join(', ') + ' or ' + list[list.length - 1]; }
  function joinAnd(list) { return list.length < 2 ? list.join('') : list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1]; }
  function names(bikes) { return bikes.length === 1 ? name(bikes[0]) : bikes.length + ' bikes'; }
  function mineWord(bikes) { return bikes.length === 1 ? short(bikes[0]) : 'bikes'; }
  var GROUP = { fits: 'fit', header: 'header', general: 'general', unknown: 'general', wrong_year: 'hidden', no_fit: 'hidden', needs_header: 'hidden', not_offered: 'hidden' };

  function cardHandle(card) {
    var h = card.getAttribute('data-product-handle');
    if (h) return h;
    var a = card.querySelector('a[href*="/products/"]');
    var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  /* handles in list order -> { fit, header, general, hidden (handles), wrongYear, perBike {id: fits}, headerBikes, hiddenHeader } */
  function classify(handles, bikes) {
    var res = { fit: [], header: [], general: [], hidden: [], wrongYear: 0, perBike: {}, headerBikes: [], hiddenHeader: 0 };
    bikes.forEach(function (b) { res.perBike[b.id] = 0; });
    handles.forEach(function (h) {
      var k = kindOf(h);
      var best = null;
      bikes.forEach(function (b) {
        var s = stateFor(h, b, k);
        if (s === 'fits') res.perBike[b.id]++;
        if (s === 'header' && res.headerBikes.indexOf(b) < 0) res.headerBikes.push(b);
        if (!best || RANK[s] > RANK[best]) best = s;
      });
      var g = GROUP[best || k.kind] || 'general';
      res[g].push(h);
      if (g === 'hidden' && best === 'wrong_year') res.wrongYear++;
      if (g === 'hidden' && k.kind === 'header') res.hiddenHeader++;
    });
    return res;
  }

  /* ----- Card chips (mobile audit defect b): in the image well, so the grid never shifts ----- */
  function chipFor(h, bikes) {
    var v = verdict(h, bikes);
    switch (v.state) {
      case 'fits': return { ok: true, text: 'Fits your ' + short(v.bike) };
      case 'header': return { ok: true, text: 'Fits Stealth headers' };
      case 'no_fit': return { ok: false, text: 'Not for your ' + short(v.bike) };
      case 'needs_header': return { ok: false, text: 'Not for stock pipes' };
      case 'not_offered': return { ok: false, text: 'Not on the ' + short(v.bike) + ' system' };
      case 'wrong_year': return { ok: false, text: 'Fits ' + yrs(v.k.part.gens[v.bike.genId]) };
    }
    return null;
  }
  var chipSig = '';
  function paintCard(card, bikes) {
    var h = cardHandle(card);
    if (!h) return;
    /* Fit line for every visitor (desktop audit blocker 1): platform parts stop reading "Fits every Stealth header" */
    var lab = fitLabelOf(h);
    var line = card.querySelector('[data-sp-kf-fit]') || card.querySelector('.sp-card-meta__fit');
    var k = kindOf(h);
    if (line && lab && (k.kind === 'part' || k.kind === 'model')) line.textContent = 'Fits ' + lab;
    var old = card.querySelector('[data-sp-kf-chipel]');
    if (old) old.remove();
    card.setAttribute('data-sp-kf-sig', chipSig);
    if (!bikes.length) return;
    var c = chipFor(h, bikes);
    if (!c) return;
    var host = card.querySelector('[data-sp-kf-chip]') || card.querySelector('.grid-product__image-mask');
    if (!host) return;
    host.insertAdjacentHTML('beforeend', '<span class="sp-kf-chip' + (c.ok ? '' : ' sp-kf-chip--no') + '" data-sp-kf-chipel title="' + esc(c.text) + '">' + (c.ok ? ICON.tick : ICON.info) + '<span>' + esc(c.text) + '</span></span>');
  }
  function paintChips(force) {
    var bikes = ordered();
    var sig = bikes.map(function (b) { return b.id + b.genId + b.year + (b.model || '') + (b.nickname || ''); }).join(',');
    if (sig !== chipSig) { chipSig = sig; force = true; }
    document.querySelectorAll('.grid-product').forEach(function (card) {
      /* Scoped: no chip in the predictive search panel (too small) or inside the quick-shop modal */
      if (card.closest('predictive-search, .modal')) return;
      if (!force && card.getAttribute('data-sp-kf-sig') === chipSig) return;
      paintCard(card, bikes);
    });
  }

  /* ----- Card fetch for fits that are not on the page (alternate template, never linked, noindex) ----- */
  var cardCache = {};
  var fetchQ = [], fetchActive = 0;
  function pump() {
    while (fetchActive < 4 && fetchQ.length) {
      var job = fetchQ.shift(); fetchActive++;
      job.fn().then(function (v) { fetchActive--; this.ok(v); pump(); }.bind(job), function (e) { fetchActive--; this.no(e); pump(); }.bind(job));
    }
  }
  function fetchCard(handle, like) {
    if (!cardCache[handle]) {
      cardCache[handle] = new Promise(function (ok, no) {
        fetchQ.push({ ok: ok, no: no, fn: function () {
          return fetch('/products/' + encodeURIComponent(handle) + '?view=sp-card', { credentials: 'same-origin' })
            .then(function (r) { if (!r.ok) throw new Error('card ' + r.status); return r.text(); });
        } });
        pump();
      });
      cardCache[handle].catch(function () { delete cardCache[handle]; });
    }
    return cardCache[handle].then(function (html) {
      var t = document.createElement('template');
      t.innerHTML = html;
      var card = t.content.querySelector('.grid-product');
      if (!card) return null;
      card = document.importNode(card, true);
      /* the fetched card takes the width classes of the list it joins */
      if (like) card.className = like.className;
      card.setAttribute('data-sp-kf-added', '');
      /* Impulse fades cards and images in through AOS, which only animates what it saw at load: show them now */
      card.classList.add('aos-animate');
      card.querySelectorAll('[data-aos]').forEach(function (el) { el.classList.add('aos-animate'); });
      return card;
    }, function () { return null; });
  }
  /* Whole-view handle list for views that span pages (/collections/all, long searches): [[handle, available], ...] */
  function fetchHandles(base) {
    var key = KF_IDX + base;
    try {
      var c = JSON.parse(window.sessionStorage.getItem(key) || 'null');
      if (c && Date.now() - c.t < 600000) return Promise.resolve(c.rows);
    } catch (e) {}
    var url = function (n) { return base + (base.indexOf('?') > -1 ? '&' : '?') + 'view=sp-handles&page=' + n; };
    var page = function (n) {
      return fetch(url(n), { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('handles ' + r.status); return r.text(); })
        .then(function (t) { var m = t.match(/<script type="application\/json" id="sp-kf-handles">([\s\S]*?)<\/script>/); if (!m) throw new Error('handles shape'); return JSON.parse(m[1]); });
    };
    return page(1).then(function (first) {
      var rest = [];
      for (var n = 2; n <= first.pages; n++) rest.push(page(n));
      return Promise.all(rest).then(function (more) {
        var rows = first.handles;
        more.forEach(function (d) { rows = rows.concat(d.handles); });
        try { window.sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), rows: rows })); } catch (e) {}
        return rows;
      });
    });
  }

  /* ----- Shared list mechanics ----- */
  /* Every server child of the grid gets its server index (products, and search's pages and articles) */
  function indexCards(grid) {
    var cards = Array.prototype.filter.call(grid.children, function (el) { return el.classList.contains('grid__item') && !el.hasAttribute('data-sp-kf-added'); });
    cards.forEach(function (c, i) { if (c.getAttribute('data-sp-kf-i') == null) c.setAttribute('data-sp-kf-i', i); });
    return cards;
  }
  /* Back to the server render: added cards and dividers out, originals unhidden in their server order */
  function restoreGrid(grid) {
    grid.querySelectorAll('[data-sp-kf-added]').forEach(function (el) { el.remove(); });
    var cards = Array.prototype.filter.call(grid.children, function (el) { return el.getAttribute('data-sp-kf-i') != null; });
    cards.sort(function (a, b) { return a.getAttribute('data-sp-kf-i') - b.getAttribute('data-sp-kf-i'); });
    cards.forEach(function (c) { c.hidden = false; grid.appendChild(c); });
  }
  function divider(title, note) {
    var d = document.createElement('div');
    d.className = 'grid__item sp-kf-div';
    d.setAttribute('data-sp-kf-added', '');
    d.innerHTML = '<p class="sp-kf-div__t" role="heading" aria-level="3">' + title + '</p>' + (note ? '<p class="sp-kf-div__n">' + note + '</p>' : '');
    return d;
  }
  function hideOriginals(grid) { Array.prototype.forEach.call(grid.children, function (el) { if (el.getAttribute('data-sp-kf-i') != null) el.hidden = true; }); }
  /* Append the next slice of a scoped list: fits, then header parts, then the rest, with a divider at each group
     boundary (L.dividers) and a "Show N more" control while items are left (views that span pages).
     L = { grid, order, cls, orig, like, shown, size, dividers, surface } */
  /* A card that is not on the page yet: a same-size ghost (a copy of a card in the list, emptied) holds its place
     so nothing shifts when the real card arrives (CLS), and the list never waits on the network. */
  function ghostOf(like) {
    var g = like ? like.cloneNode(true) : document.createElement('div');
    g.className = (like ? like.className : 'grid__item grid-product') + ' sp-kf-ghost';
    ['data-sp-kf-i', 'data-product-handle', 'data-product-id', 'data-sp-kf-sig', 'id'].forEach(function (a) { g.removeAttribute(a); });
    g.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
    g.querySelectorAll('[data-sp-kf-chipel]').forEach(function (el) { el.remove(); });
    g.setAttribute('aria-hidden', 'true');
    g.inert = true;
    g.hidden = false;
    g.setAttribute('data-sp-kf-added', '');
    return g;
  }
  function appendMore(L) {
    var slice = L.order.slice(L.shown, L.shown + L.size), start = L.shown;
    var old = L.grid.querySelector('[data-sp-kf-morerow]');
    if (old) old.remove();
    var nF = L.cls.fit.length, nH = L.cls.header.length, placed = 0, waits = [];
    slice.forEach(function (h, i) {
      var gi = start + i;
      if (L.dividers && nF && nH && gi === nF) L.grid.appendChild(divider('Fits every Stealth header', 'Universal 2.25 inch parts. They bolt to a Stealth header, not stock pipes.'));
      if (L.dividers && (nF || nH) && L.cls.general.length && gi === nF + nH) L.grid.appendChild(divider('Not tied to one bike', ''));
      var node = L.orig[h];
      if (node) { node.hidden = false; L.grid.appendChild(node); placed++; return; }
      var ghost = ghostOf(L.like);
      L.grid.appendChild(ghost);
      placed++;
      waits.push(fetchCard(h, L.like).then(function (card) {
        if (!ghost.parentNode) return;
        if (card) ghost.parentNode.replaceChild(card, ghost);
        else { ghost.remove(); placed--; }
      }));
    });
    L.shown = start + slice.length;
    var left = L.order.length - L.shown;
    if (left > 0 && L.surface) {
      var row = document.createElement('div');
      var n = Math.min(left, L.size);
      row.className = 'grid__item sp-kf-morerow';
      row.setAttribute('data-sp-kf-added', '');
      row.setAttribute('data-sp-kf-morerow', '');
      row.innerHTML = btn('more', L.surface, 'Show ' + n + ' more');
      L.grid.appendChild(row);
    }
    paintChips(true);
    /* placed now (ghosts count); .loaded resolves when every fetched card has replaced its ghost */
    L.loaded = Promise.all(waits).then(function () { paintChips(true); L.placed = (L.placed || 0) + placed; return L.placed; });
    return Promise.resolve(placed);
  }
  function btn(action, surface, text) { return '<button type="button" class="sp-kf-btn" data-sp-kf-action="' + action + '" data-surface="' + surface + '">' + esc(text) + '</button>'; }
  var CHANGE = '<button type="button" class="sp-kf-tlink" data-sp-garage-open>Change bike</button>';
  function shopEach(bikes) { return bikes.slice(0, 3).map(function (b) { return '<a class="sp-kf-btn" href="' + shopUrl(b) + '">Shop parts for my ' + esc(short(b)) + '</a>'; }).join(''); }
  /* Why a headerless bike sees so little: the honest line from kit.headerGens */
  function headerlessLine(bikes) {
    if (bikes.length !== 1 || takesHeader(bikes[0])) return '';
    var r = findGen(bikes[0].genId);
    return 'Your ' + esc(short(bikes[0])) + ' runs its own ' + (r && r.gen.systems.length ? 'system' : 'slip-on') + ', with no Stealth header.';
  }
  var tracked = {};
  function trackOnce(key, n, data) { if (tracked[key]) return; tracked[key] = 1; publish(n, data); }

  /* ----- Collection and search pre-filter (design section 4) ----- */
  function scopeView(slot) {
    var surface = slot.getAttribute('data-sp-kf-banner');
    var scope = slot.closest('[data-sp-kf-scope]') || slot.parentNode;
    /* data-sp-kf-grid / data-sp-kf-count are Collection V3's stable hooks (sp2-collection); classes are the fallback */
    var grid = scope.querySelector('[data-sp-kf-grid]') || scope.querySelector('.collection-grid__wrapper .grid--uniform');
    var foot = scope.querySelector('[data-sp-kf-foot]');
    var countEl = scope.querySelector('[data-sp-kf-count]') || scope.querySelector('.collection-filter__item--count');
    var pager = scope.querySelector('.pagination');
    var html = document.documentElement;
    if (!grid) { html.classList.remove('sp-kf-hold'); return; }
    var noun = slot.getAttribute('data-sp-kf-noun') || 'product';
    var total = +slot.getAttribute('data-sp-kf-total') || 0;
    var pages = +slot.getAttribute('data-sp-kf-pages') || 1;
    if (countEl && countEl._spText == null) countEl._spText = countEl.textContent.trim();
    var items = indexCards(grid);
    var cards = items.filter(function (c) { return c.classList.contains('grid-product'); });
    /* search pages and articles: never hidden, after the products */
    var others = items.filter(function (c) { return !c.classList.contains('grid-product') || !cardHandle(c); });
    var orig = {};
    cards.forEach(function (c) { var h = cardHandle(c); if (h && !orig[h]) orig[h] = c; });
    var q = surface === 'search' ? (new URLSearchParams(location.search).get('q') || '').toLowerCase().trim() : '';
    var allBikes = ordered();
    var selId = kfSel(surface);
    var bikes = allBikes.filter(function (b) { return !selId || b.id === selId; });
    if (!bikes.length) bikes = allBikes;
    var sig = [allBikes.map(function (b) { return b.id + b.year + b.genId; }).join(','), kfAll(surface), selId, kfQ(q), items.length].join('|');
    if (slot._spSig === sig) return;
    slot._spSig = sig;
    var run = (slot._spRun = (slot._spRun || 0) + 1);

    function done() { if (slot._spRun === run) html.classList.remove('sp-kf-hold', 'sp-kf-hold-line'); }
    /* After every scope run: Collection V3 renders its bike chips (scoped counts) and toolbar from this */
    function scoped(mode, handles, shown) {
      var per = allBikes.map(function (b) { var c = classify(handles || [], [b]); return { id: b.id, label: label(b), short: short(b), count: c.fit.length + c.header.length }; });
      try { document.dispatchEvent(new CustomEvent('sp:kf-scoped', { detail: { surface: surface, mode: mode, bikes: per, shown: shown, total: total, selected: selId || null } })); } catch (e) {}
    }
    function setBanner(mode, inner) {
      slot.setAttribute('data-mode', mode || '');
      /* the collection note's bike chip steps aside while a banner names the bike (CSS) */
      html.classList.toggle('sp-kf-scoped', !!document.querySelector('[data-sp-kf-banner][data-mode="fit"], [data-sp-kf-banner][data-mode="zero"], [data-sp-kf-banner][data-mode="all"]'));
      if (!inner) { slot.hidden = true; slot.innerHTML = ''; return; }
      slot.hidden = false;
      slot.innerHTML = inner;
    }
    /* key: the note carries the next step (the system for a stock-pipe rider, the headerless line, the zero guard),
       so Collection V3 keeps it visible at 390 (.sp-kf-bar__note--key) */
    function banner(title, note, actions, zero, key) {
      return '<div class="sp-kf-banner' + (zero ? ' sp-kf-banner--zero' : '') + '"><span class="sp-kf-banner__icon">' + ICON.bike + '</span><div class="sp-kf-banner__body">' +
        '<p class="sp-kf-banner__title sp-kf-bar__title" aria-live="polite">' + title + '</p>' + (note ? '<p class="sp-kf-banner__note sp-kf-bar__note' + (zero || key ? ' sp-kf-bar__note--key' : '') + '">' + note + '</p>' : '') +
        '<div class="sp-kf-actions sp-kf-bar__actions">' + actions + '</div></div></div>';
    }
    function setFoot(inner) { if (!foot) return; foot.hidden = !inner; foot.innerHTML = inner || ''; }
    function reset() {
      restoreGrid(grid);
      grid.removeAttribute('data-sp-kf-mode');
      if (countEl) countEl.textContent = countEl._spText;
      if (pager) pager.hidden = false;
      setFoot('');
    }

    reset();
    if (!bikes.length || isDealer()) { setBanner('', ''); paintChips(true); scoped('none', [], cards.length); return done(); }

    var handlesP = pages > 1 ? fetchHandles(location.pathname + (location.search ? location.search.replace(/([?&])(page|view)=[^&]*/g, '$1').replace(/[?&]+$/, '') : ''))
      .then(function (rows) { return rows.map(function (r) { return r[0]; }); }) : Promise.resolve(cards.map(cardHandle).filter(Boolean));

    handlesP.then(function (handles) {
      if (slot._spRun !== run) return;
      /* Shopify's own count (search counts pages too); a view over several pages counts its handle list */
      total = pages > 1 ? Math.max(handles.length + others.length, total) : total || handles.length;
      var cls = classify(handles, bikes);
      var nFit = cls.fit.length, nHead = cls.header.length;
      var all = kfAll(surface);
      /* The query names another bike ("dyna" with a Softail saved): the rider asked, so everything shows, with the
         way back one tap away for this query */
      var asked = q ? queryFamilies(q) : [];
      var other = asked.length && !bikes.some(function (b) { return asked.indexOf(b.family) > -1; });
      if (other && kfQ(q) !== 'fit') {
        grid.setAttribute('data-sp-kf-mode', 'all');
        scoped('all', handles, handles.length);
        setBanner('all', '<div class="sp-kf-banner sp-kf-banner--line"><p class="sp-kf-banner__title sp-kf-bar__title" aria-live="polite">Showing all ' + total + ' ' + plural(total, noun) + ' for ' + esc(q) + '.</p><div class="sp-kf-actions sp-kf-bar__actions">' + (nFit + nHead ? btn('fitq', surface, 'Show what fits my ' + mineWord(bikes)) : '') + CHANGE + '</div></div>');
        return done();
      }
      var nounP = plural(total, noun);
      if (!nFit && !nHead) {
        if (!cls.hidden.length) { setBanner('', ''); scoped('none', handles, handles.length); return done(); } /* nothing bike-specific here (apparel) */
        /* Zero guard: nothing hidden, the next step goes to the bike's own parts */
        grid.setAttribute('data-sp-kf-mode', 'zero');
        var why = cls.hiddenHeader ? 'These bolt to a Stealth header or fit other bikes. ' + headerlessLine(bikes) : '';
        if (cls.wrongYear && bikes.length === 1) why += (why ? ' ' : '') + cls.wrongYear + ' ' + plural(cls.wrongYear, noun) + ' here fit other ' + esc(short(bikes[0])) + ' years.';
        setBanner('zero', banner('Nothing here is built for your ' + esc(names(bikes)), why.trim(), shopEach(bikes) + CHANGE, true));
        trackOnce(sig + 'z', 'known_fit_zero', { surface: surface, bikes: bikes.length, path: location.pathname });
        scoped('zero', handles, handles.length);
        return done();
      }
      if (all) {
        grid.setAttribute('data-sp-kf-mode', 'all');
        scoped('all', handles, handles.length);
        setBanner('all', '<div class="sp-kf-banner sp-kf-banner--line"><p class="sp-kf-banner__title sp-kf-bar__title" aria-live="polite">Showing all ' + total + ' ' + nounP + '.</p><div class="sp-kf-actions sp-kf-bar__actions">' + btn('fit', surface, 'Show what fits my ' + mineWord(bikes)) + '</div></div>');
        return done();
      }
      var withFits = bikes.filter(function (b) { return cls.perBike[b.id] > 0; });
      var notes = [];
      var title;
      if (nFit) {
        title = nFit + ' ' + plural(nFit, noun) + ' ' + (nFit === 1 ? 'fits' : 'fit') + ' your ' + esc(names(withFits));
        if (nHead) notes.push('Plus ' + nHead + ' that bolt to the Stealth header on your ' + esc(joinAnd(cls.headerBikes.map(name))) + '.');
      } else {
        title = nHead + ' ' + plural(nHead, noun) + ' fit your ' + esc(names(cls.headerBikes)) + ' on a Stealth header';
        /* The rider on stock pipes gets the system that comes with any of these (kit builder logic) */
        var sysBike = cls.headerBikes.filter(function (b) { var r = findGen(b.genId); return r && r.gen.systems.length === 1; })[0];
        if (sysBike && cls.header.some(function (h) { return (V.universalHandles || []).indexOf(h) > -1; })) notes.push('On stock pipes? <a href="' + shopUrl(sysBike) + '">The ' + esc(short(sysBike)) + ' system</a> comes with your pick of these.');
      }
      var none = bikes.filter(function (b) { return !cls.perBike[b.id] && cls.headerBikes.indexOf(b) < 0; });
      if (bikes.length > 1 && none.length) notes.push('None fit your ' + esc(joinOr(none.map(name))) + ' here.');
      if (bikes.length === 1 && cls.hiddenHeader && nFit) notes.push('The others bolt to a Stealth header or fit other bikes. ' + headerlessLine(bikes));
      if (cls.wrongYear && bikes.length === 1) notes.push(cls.wrongYear + ' more fit other ' + esc(short(bikes[0])) + ' years.');
      var showAll = cls.hidden.length ? btn('all', surface, 'Show all ' + total) : '';
      grid.setAttribute('data-sp-kf-mode', 'fit');
      var shown = nFit + nHead + cls.general.length + others.length;
      var order = cls.fit.concat(cls.header, cls.general);
      slot._spList = { grid: grid, order: order, cls: cls, orig: orig, like: cards[0], shown: 0, size: pages > 1 ? Math.max(cards.length, 24) : order.length, dividers: true, surface: surface };
      hideOriginals(grid);
      return appendMore(slot._spList).then(function () {
        others.forEach(function (o) { o.hidden = false; grid.appendChild(o); });
        if (slot._spRun !== run) return;
        setBanner('fit', banner(title, notes.join(' ').trim(), showAll + CHANGE, false, !nFit || (bikes.length === 1 && !takesHeader(bikes[0]))));
        if (countEl && cls.hidden.length) countEl.textContent = shown + ' of ' + countEl._spText;
        if (pager && pages > 1) pager.hidden = true;
        var served = withFits.concat(cls.headerBikes).filter(function (b, i, a) { return a.indexOf(b) === i; });
        if (cls.hidden.length) setFoot('<p>You are seeing what fits your ' + esc(names(served)) + '.</p><div class="sp-kf-actions">' + btn('all', surface, 'Show all ' + total) + '</div>');
        paintChips(true);
        trackOnce(sig + 'a', 'known_fit_apply', { surface: surface, bikes: bikes.length, results: nFit, header: nHead, total: total, path: location.pathname });
        scoped(nFit ? 'fit' : 'header', handles, shown);
        done();
      });
    }).catch(function (err) {
      if (slot._spRun !== run) return;
      try { console.warn('[SP known fit] list failed', err); } catch (e) {}
      slot._spSig = '';
      reset(); setBanner('', ''); done();
    });
  }

  /* ----- Rows: home best sellers, the landing rows, 404 and empty-search "Start with a full system" (6.1).
     Contract for Home V3: a root [data-sp-kf="row"] with data-sp-kf-handles="handle:1,handle:0,..." (the source
     collection in its own order, :0 = sold out), a .grid--uniform of shared cards, and an empty
     [data-sp-kf-label] slot under the heading. ----- */
  function scopeRow(root) {
    var grid = root.querySelector('.grid--uniform');
    var slot = root.querySelector('[data-sp-kf-label]');
    if (!grid || !slot) return;
    var items = indexCards(grid);
    var cards = items.filter(function (c) { return c.classList.contains('grid-product'); });
    /* the row's "View all" tile is not a product: never hidden, kept after the products */
    var rest = items.filter(function (c) { return cards.indexOf(c) < 0; });
    var orig = {};
    cards.forEach(function (c) { var h = cardHandle(c); if (h && !orig[h]) orig[h] = c; });
    var limit = cards.length;
    var src = (root.getAttribute('data-sp-kf-handles') || '').split(',').filter(Boolean).map(function (x) { var p = x.split(':'); return { h: p[0], ok: p[1] !== '0' }; });
    var bikes = ordered();
    var sig = [bikes.map(function (b) { return b.id + b.year + b.genId; }).join(','), kfAll('home_row')].join('|');
    if (root._spSig === sig) return;
    root._spSig = sig;
    var run = (root._spRun = (root._spRun || 0) + 1);
    restoreGrid(grid);
    root.querySelectorAll('[data-sp-kf-more]').forEach(function (el) { el.remove(); });
    grid.removeAttribute('data-sp-kf-mode');
    /* the label follows the row heading's own alignment (V2 centres headings whatever the theme setting says) */
    var h2 = root.querySelector('.section-header__title');
    if (h2 && getComputedStyle(h2).textAlign === 'center') slot.classList.add('sp-kf-label--center');
    var setLabel = function (inner) { slot.hidden = !inner; slot.innerHTML = inner || ''; };
    if (!bikes.length || isDealer() || !limit) { setLabel(''); return; }
    var inStock = src.filter(function (x) { return x.ok; }).map(function (x) { return x.h; });
    var cls = classify(inStock.length ? inStock : cards.map(cardHandle), bikes);
    var nFit = cls.fit.length + cls.header.length;
    if (!nFit) {
      if (!cls.hidden.length) { setLabel(''); return; }
      grid.setAttribute('data-sp-kf-mode', 'zero');
      setLabel('<span>None of these fit your ' + esc(names(bikes)) + '.</span>' + bikes.slice(0, 2).map(function (b) { return '<a class="sp-kf-tlink" href="' + shopUrl(b) + '">Shop parts for my ' + esc(short(b)) + '</a>'; }).join(''));
      trackOnce(sig + location.pathname + 'rz', 'known_fit_zero', { surface: 'home_row', bikes: bikes.length, path: location.pathname });
      return;
    }
    if (kfAll('home_row')) { setLabel(btn('fit', 'home_row', 'Show what fits my ' + mineWord(bikes))); return; }
    var withFits = bikes.filter(function (b) { return cls.perBike[b.id] > 0; }).concat(cls.headerBikes).filter(function (b, i, a) { return a.indexOf(b) === i; });
    var rowCls = { fit: cls.fit, header: cls.header, general: [] };
    hideOriginals(grid);
    var RL = { grid: grid, order: cls.fit.concat(cls.header).slice(0, limit), cls: rowCls, orig: orig, like: cards[0], shown: 0, size: limit, dividers: false, surface: '' };
    appendMore(RL).then(function (placed) {
      rest.forEach(function (o) { o.hidden = false; grid.appendChild(o); });
      if (root._spRun !== run) return;
      grid.setAttribute('data-sp-kf-mode', 'fit');
      setLabel('<span>For your ' + esc(names(withFits)) + '</span>' + btn('all', 'home_row', 'Show all'));
      if (placed < limit) {
        var more = document.createElement('p');
        more.className = 'sp-kf-more' + (slot.classList.contains('sp-kf-label--center') ? ' sp-kf-more--center' : '');
        more.setAttribute('data-sp-kf-more', '');
        more.innerHTML = withFits.slice(0, 2).map(function (b) { return '<a class="sp-kf-tlink" href="' + shopUrl(b) + '">Shop everything for my ' + esc(name(b)) + '</a>'; }).join('');
        grid.parentNode.insertBefore(more, grid.nextSibling);
      }
      paintChips(true);
      trackOnce(sig + location.pathname + (root.id || ''), 'known_fit_apply', { surface: 'home_row', bikes: bikes.length, results: placed, total: inStock.length, path: location.pathname });
    });
  }

  /* ----- PDP related (Impulse product-recommendations): scoped only when the product on screen fits a saved
     bike; otherwise the rider is shopping another bike and the list stays. ----- */
  function pdpHandle() {
    var f = document.querySelector('[data-sp-fitline][data-handle], [data-sp-fitment]');
    if (f) return f.dataset.handle;
    var s = document.querySelector('[data-section-type="product"][data-product-handle]');
    return s ? s.getAttribute('data-product-handle') : '';
  }
  /* PDP V3 (sp2-pdp): root [data-sp-kf="pdp_related"], cards with data-product-handle, an empty [data-sp-kf-label]
     slot, sp:related:ready after each render. Impulse product-recommendations is the fallback until V3 merges. */
  function scopeRelated(root) {
    var v3 = root.getAttribute('data-sp-kf') === 'pdp_related';
    /* Impulse copies the loaded cards into .product-recommendations-placeholder, so read cards anywhere inside */
    var cards = Array.prototype.slice.call(root.querySelectorAll(v3 ? '[data-product-handle]' : '.grid-product'));
    var grid = cards.length ? cards[0].parentNode : null;
    if (!grid) return;
    if (!cards.length) return;
    var bikes = ordered();
    var sig = [bikes.map(function (b) { return b.id + b.year + b.genId; }).join(','), kfAll('pdp_related'), cards.length].join('|');
    if (root._spSig === sig) return;
    root._spSig = sig;
    var slot = root.querySelector('[data-sp-kf-label]');
    if (!slot) {
      var head = root.querySelector('.section-header__title') ? root.querySelector('.section-header__title').parentNode : root.querySelector('.section-header');
      slot = document.createElement('p');
      slot.className = 'sp-kf-label';
      slot.setAttribute('data-sp-kf-label', '');
      if (head) head.appendChild(slot); else grid.parentNode.insertBefore(slot, grid);
    }
    cards.forEach(function (c) { c.hidden = false; });
    slot.hidden = true; slot.innerHTML = '';
    var own = pdpHandle();
    if (!bikes.length || isDealer() || !own) return;
    var ov = verdict(own, bikes);
    if (ov.state !== 'fits' && ov.state !== 'header') return;
    var mine = bikes.filter(function (b) { var s = stateFor(own, b, kindOf(own)); return s === 'fits' || s === 'header'; });
    if (kfAll('pdp_related')) { slot.hidden = false; slot.innerHTML = btn('fit', 'pdp_related', 'Show related for my ' + mineWord(mine)); return; }
    var keep = cards.filter(function (c) { return GROUP[verdict(cardHandle(c), mine).state] !== 'hidden'; });
    if (!keep.length || keep.length === cards.length) return;
    cards.forEach(function (c) { if (keep.indexOf(c) < 0) c.hidden = true; });
    slot.hidden = false;
    slot.innerHTML = '<span>Fits your ' + esc(names(mine)) + '</span>' + btn('all', 'pdp_related', 'Show all related');
    trackOnce(sig + 'r', 'known_fit_apply', { surface: 'pdp_related', bikes: mine.length, results: keep.length, total: cards.length, path: location.pathname });
  }

  /* ----- Relabels (design 7.1): the hero primary and the newsletter heading name the active bike. Text and href
     only, restored when the garage empties. ----- */
  function relabel() {
    var b = api.active();
    var r = b ? findGen(b.genId) : null;
    document.querySelectorAll('a[href$="#bike-finder"], [data-sp-kf-hero]').forEach(function (a) {
      if (a.closest('[data-sp-garage-drawer], .sp-finder, [data-sp-navbike], header')) return;
      if (a._spKf == null) a._spKf = { href: a.getAttribute('href'), text: a.textContent };
      var labelled = a.textContent.trim() !== '' && !a.hasAttribute('aria-hidden');
      if (!b) { a.setAttribute('href', a._spKf.href); if (labelled) a.textContent = a._spKf.text; a.removeAttribute('data-sp-kf-click'); return; }
      a.setAttribute('href', shopUrl(b));
      a.setAttribute('data-sp-kf-click', 'hero');
      if (!labelled) return;
      var one = r && r.gen.systems.length === 1, slip = r && !r.gen.systems.length && r.gen.slipons.length === 1;
      a.textContent = (one ? 'See the system for my ' : slip ? 'See the slip-on for my ' : 'Shop exhaust for my ') + name(b);
    });
    document.querySelectorAll('[data-sp-kf-news]').forEach(function (h) {
      if (h._spKf == null) h._spKf = h.textContent;
      var hasSys = r && r.gen.systems.length > 0;
      h.textContent = b && hasSys && /your first system/i.test(h._spKf) ? h._spKf.replace(/your first system/i, 'your ' + name(b) + ' system') : h._spKf;
    });
  }

  function renderLists() {
    paintChips(false);
    document.querySelectorAll('[data-sp-kf-banner]').forEach(scopeView);
    document.querySelectorAll('[data-sp-kf="row"]').forEach(scopeRow);
    document.querySelectorAll('[data-sp-kf="pdp_related"], product-recommendations[data-section-type="product-recommendations"]:not([data-intent="complementary"])').forEach(scopeRelated);
    preselectAll();
    relabel();
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-sp-kf-action]');
    if (el) {
      e.preventDefault();
      var surface = el.getAttribute('data-surface');
      if (el.getAttribute('data-sp-kf-action') === 'more') {
        var s = document.querySelector('[data-sp-kf-banner="' + surface + '"]');
        if (s && s._spList) {
          var at = s._spList.order[s._spList.shown];
          appendMore(s._spList);
          /* focus the first new card once it is real (ghosts are inert) */
          s._spList.loaded.then(function () { var n = s._spList.grid.querySelector('.grid-product[data-product-handle="' + at + '"]'); var a = n && n.querySelector('a[href]'); if (a) a.focus(); });
        }
        return;
      }
      if (el.getAttribute('data-sp-kf-action') === 'fitq') {
        try { window.sessionStorage.setItem(KF_Q + (new URLSearchParams(location.search).get('q') || '').toLowerCase().trim(), 'fit'); } catch (e2) {}
        kfSetAll(surface, false);
        renderLists();
        return;
      }
      var all = el.getAttribute('data-sp-kf-action') === 'all';
      kfSetAll(surface, all);
      if (all) publish('known_fit_show_all', { surface: surface, path: location.pathname });
      renderLists();
      /* keep the rider where they were: focus the control that now holds the way back (the lists land a tick later) */
      setTimeout(function () {
        var again = document.querySelector('[data-sp-kf-banner="' + surface + '"] [data-sp-kf-action], [data-sp-kf-action][data-surface="' + surface + '"]');
        if (again) again.focus({ preventScroll: true });
      }, 60);
      return;
    }
    var c = e.target.closest && e.target.closest('[data-sp-kf-click]');
    if (c) publish('known_fit_click', { surface: c.getAttribute('data-sp-kf-click'), path: location.pathname });
  });
  document.addEventListener('recommendations:loaded', function () { setTimeout(renderLists, 0); });
  /* Collection V3 swaps #CollectionAjaxContent by Section Rendering and says so */
  document.addEventListener('sp:collection-updated', function () { setTimeout(renderLists, 0); });
  document.addEventListener('sp:related:ready', function (e) { var r = e.detail && e.detail.root; if (r) r._spSig = ''; setTimeout(renderLists, 0); });
  /* Impulse swaps the collection grid by AJAX (filters, sort) and builds recently viewed and recommendations
     client-side: re-run on new cards. */
  (function watch() {
    if (!('MutationObserver' in window)) return;
    var t;
    new MutationObserver(function (muts) {
      var hit = muts.some(function (m) { return Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && !n.hasAttribute('data-sp-kf-added') && !n.hasAttribute('data-sp-kf-chipel') && (n.matches('.grid-product, #CollectionAjaxContent, [data-sp-kf-banner]') || (n.querySelector && n.querySelector('.grid-product'))); }); });
      if (!hit) return;
      clearTimeout(t);
      t = setTimeout(renderLists, 60);
    }).observe(document.body, { childList: true, subtree: true });
  })();
  /* Dealers are flagged after load (Wholesale Gorilla): drop any scope and keep the chips */
  document.addEventListener('sp:dealer-ready', function () {
    document.querySelectorAll('[data-sp-kf-banner], [data-sp-kf="row"], [data-sp-kf="pdp_related"], product-recommendations[data-section-type="product-recommendations"]').forEach(function (el) { el._spSig = ''; });
    renderLists();
  });
  /* Never leave a list held invisible */
  setTimeout(function () { document.documentElement.classList.remove('sp-kf-hold'); }, 3000);

  function boot() { render(); renderLists(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { render(); renderLists(); });
  document.addEventListener('quickview:loaded', render);
  /* Lists follow every garage change (add, switch, model, remove) */
  api.onChange(function () { renderLists(); });
})();
